const DEFAULT_COLOR = "#6C757D";
const MENU_ICON_COLOR = "#6C757D";

export const HomeIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.69604 10.7588V17.4528"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.25 7.5553V17.4533"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.729 14.2961V17.4531"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2499 22.2716C4.94794 22.2716 2.51294 19.8366 2.51294 12.5346C2.51294 5.23261 4.94794 2.79761 12.2499 2.79761C19.5519 2.79761 21.9869 5.23261 21.9869 12.5346C21.9869 18.2326 20.5049 20.9666 16.3839 21.8936"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DraftIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.52859 2.25004H13.179C13.9398 2.25004 14.6697 2.55934 15.198 3.11012C15.1979 3.11002 15.1981 3.11023 15.198 3.11012L18.9897 7.05941C19.4904 7.58143 19.7698 8.27654 19.7698 8.99839V10.2983C19.7698 10.7125 19.434 11.0483 19.0198 11.0483C18.6056 11.0483 18.2698 10.7125 18.2698 10.2983V8.99839C18.2698 8.66371 18.1404 8.34098 17.9076 8.09826C17.9076 8.09819 17.9077 8.09834 17.9076 8.09826L14.116 4.14897C13.8718 3.89434 13.5331 3.75004 13.179 3.75004H7.52384C5.89495 3.74304 4.55984 5.03877 4.51652 6.6659V17.1636L4.51635 17.1798C4.48058 18.836 5.79097 20.2083 7.44536 20.249L11.4388 20.25L11.4394 21L11.4391 21.75L7.43657 21.749L7.42002 21.7488C4.93603 21.694 2.96748 19.6381 3.01652 17.1558V6.65646L3.01674 6.63857C3.07511 4.19152 5.08042 2.24043 7.52859 2.25004ZM11.4394 21L11.4391 21.75C11.8534 21.7501 12.1893 21.4144 12.1894 21.0002C12.1895 20.586 11.853 20.2501 11.4388 20.25L11.4394 21Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6621 2.3125C14.0763 2.3125 14.4121 2.64829 14.4121 3.0625V5.95514C14.4114 6.95244 15.2189 7.76262 16.2171 7.76503H18.9551C19.3693 7.76503 19.7051 8.10082 19.7051 8.51503C19.7051 8.92924 19.3693 9.26503 18.9551 9.26503H16.2146C14.3897 9.26126 12.9111 7.78096 12.9121 5.95514C12.9121 5.95506 12.9121 5.95522 12.9121 5.95514V3.0625C12.9121 2.64829 13.2479 2.3125 13.6621 2.3125Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.31641 9.98047C7.31641 9.56626 7.65219 9.23047 8.06641 9.23047H10.5348C10.949 9.23047 11.2848 9.56626 11.2848 9.98047C11.2848 10.3947 10.949 10.7305 10.5348 10.7305H8.06641C7.65219 10.7305 7.31641 10.3947 7.31641 9.98047ZM7.31736 14.1089C7.31736 13.6947 7.65314 13.3589 8.06736 13.3589H12.796C13.2102 13.3589 13.546 13.6947 13.546 14.1089C13.546 14.5232 13.2102 14.8589 12.796 14.8589H8.06736C7.65314 14.8589 7.31736 14.5232 7.31736 14.1089Z"
      fill={color}
    />
    <path
      d="M16.0697 21.7002C15.7184 21.6999 15.378 21.5777 15.1067 21.3545C14.8353 21.1313 14.6498 20.8209 14.5818 20.4762L14.4478 19.8052C14.3215 19.1699 14.4302 18.5103 14.7538 17.9492L17.1827 13.7432C17.3012 13.5377 17.4591 13.3576 17.6472 13.2131C17.8354 13.0687 18.0501 12.9627 18.2792 12.9013C18.5084 12.84 18.7473 12.8243 18.9825 12.8554C19.2176 12.8864 19.4444 12.9634 19.6497 13.0822L20.4287 13.5322C20.8438 13.7716 21.1471 14.1658 21.2719 14.6285C21.3968 15.0911 21.3331 15.5844 21.0948 16.0002L18.6627 20.2002C18.3384 20.7611 17.8213 21.1851 17.2077 21.3932L16.5567 21.6142C16.4003 21.6696 16.2357 21.6986 16.0697 21.7002ZM18.7477 14.3402C18.7201 14.3401 18.6926 14.3435 18.6657 14.3502C18.6273 14.3605 18.5914 14.3784 18.56 14.4028C18.5286 14.4272 18.5023 14.4575 18.4828 14.4922L16.0527 18.7002C15.9117 18.9466 15.8638 19.2354 15.9178 19.5142L16.0518 20.1862L16.7267 19.9792C16.9953 19.8875 17.2215 19.7017 17.3637 19.4562L19.7907 15.2562C19.8311 15.1857 19.842 15.1021 19.821 15.0236C19.8 14.9451 19.7489 14.8781 19.6787 14.8372L18.8997 14.3872C18.8542 14.3581 18.8017 14.3419 18.7477 14.3402Z"
      fill={color}
    />
  </svg>
);

export const CarePlanIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.355 21.75H8.032C4.723 21.75 2.5 19.429 2.5 15.974V8.026C2.5 4.571 4.723 2.25 8.032 2.25H16.466C19.776 2.25 22 4.571 22 8.026V13.919C22.003 14.7393 21.6863 15.5284 21.117 16.119L16.642 20.78C16.3453 21.0867 15.9899 21.3306 15.597 21.4973C15.2041 21.6639 14.7818 21.7498 14.355 21.75ZM8.032 3.75C5.583 3.75 4 5.428 4 8.026V15.974C4 18.574 5.583 20.25 8.032 20.25H14.355C14.5792 20.249 14.801 20.203 15.0071 20.1147C15.2133 20.0264 15.3996 19.8976 15.555 19.736L20.03 15.075C20.3291 14.7646 20.4959 14.3501 20.495 13.919V8.026C20.495 5.426 18.912 3.75 16.461 3.75H8.032Z"
      fill={color}
    />
    <path
      d="M14.9258 21.6782C14.7269 21.6782 14.5361 21.5992 14.3954 21.4585C14.2548 21.3179 14.1758 21.1271 14.1758 20.9282V17.5142C14.1768 16.5158 14.5732 15.5585 15.2782 14.8517C15.9832 14.1448 16.9394 13.7459 17.9378 13.7422H21.1728C21.3717 13.7422 21.5625 13.8212 21.7031 13.9619C21.8438 14.1025 21.9228 14.2933 21.9228 14.4922C21.9228 14.6911 21.8438 14.8819 21.7031 15.0225C21.5625 15.1632 21.3717 15.2422 21.1728 15.2422H17.9398C17.3387 15.2446 16.763 15.4849 16.3387 15.9107C15.9144 16.3365 15.676 16.9131 15.6758 17.5142V20.9282C15.6758 21.1271 15.5968 21.3179 15.4561 21.4585C15.3155 21.5992 15.1247 21.6782 14.9258 21.6782Z"
      fill={color}
    />
    <path
      d="M9.78217 12.9778C9.65606 12.9777 9.53197 12.9461 9.42117 12.8858C9.16817 12.7468 6.93218 11.4768 6.36318 9.66778C6.24126 9.3408 6.18556 8.99287 6.19931 8.64416C6.21307 8.29546 6.296 7.95296 6.4433 7.6366C6.5906 7.32023 6.79932 7.03628 7.05732 6.8013C7.31532 6.56631 7.61746 6.38497 7.94618 6.26779C8.55087 6.07872 9.20413 6.12003 9.78018 6.38379C10.3568 6.11674 11.0125 6.07536 11.6182 6.26779C11.9467 6.38518 12.2487 6.56667 12.5065 6.80173C12.7643 7.03678 12.9729 7.3207 13.12 7.63702C13.2672 7.95334 13.3501 8.29576 13.3639 8.64438C13.3776 8.99299 13.322 9.34085 13.2002 9.66778C12.6132 11.4918 10.3922 12.7448 10.1412 12.8818C10.0314 12.9434 9.90799 12.9764 9.78217 12.9778ZM8.71218 7.6488C8.60666 7.64878 8.50177 7.66497 8.40118 7.69681C8.26116 7.75589 8.13425 7.84213 8.02776 7.95056C7.92128 8.05899 7.83735 8.18743 7.78082 8.32849C7.72428 8.46955 7.69626 8.62044 7.69838 8.7724C7.7005 8.92435 7.73272 9.07438 7.79318 9.2138C8.22862 10.1089 8.9216 10.8534 9.78317 11.3518C10.6438 10.8521 11.3363 10.1075 11.7722 9.2128C11.8324 9.07303 11.8643 8.92274 11.8661 8.77057C11.8679 8.61839 11.8395 8.46738 11.7826 8.32623C11.7257 8.18509 11.6414 8.05659 11.5346 7.94821C11.4277 7.83983 11.3005 7.75371 11.1602 7.69479C11.0039 7.64501 10.8379 7.63327 10.6761 7.66058C10.5144 7.68789 10.3615 7.75346 10.2302 7.85181C10.1007 7.94731 9.94406 7.99884 9.78317 7.99884C9.62229 7.99884 9.46564 7.94731 9.33618 7.85181C9.15543 7.71877 8.9366 7.64757 8.71218 7.6488Z"
      fill={color}
    />
  </svg>
);

export const BuilderIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.65 4.08339C12.922 3.63887 12.0208 3.63887 11.293 4.08339L5.96975 7.33414C5.96973 7.33414 5.96976 7.33413 5.96975 7.33414C5.43264 7.66223 5.43259 8.47144 5.9697 8.79954C5.96969 8.79953 5.96972 8.79954 5.9697 8.79954L11.293 12.0503C12.0208 12.4948 12.922 12.4948 13.65 12.0503L18.9732 8.79954C19.511 8.47139 19.5112 7.66244 18.9735 7.33429L13.65 4.08339ZM14.3782 2.78937C13.2006 2.07021 11.7424 2.07021 10.5647 2.78937L5.24144 6.04013C3.7554 6.94775 3.75537 9.18592 5.2414 10.0935L10.5647 13.3443C11.7423 14.0635 13.2006 14.0635 14.3782 13.3443L19.7012 10.0937C21.1884 9.18606 21.1885 6.94752 19.7012 6.04001L14.3782 2.78937Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.97688 11.3347C10.1971 11.6796 10.1072 12.1452 9.77614 12.3746L5.78536 15.1395C5.78533 15.1395 5.78538 15.1394 5.78536 15.1395C5.28423 15.4874 5.30631 16.2618 5.82461 16.5779L11.2911 19.9164C12.0192 20.361 12.9211 20.3608 13.6478 19.9166L19.0956 16.5898C19.6176 16.2712 19.6369 15.493 19.1308 15.1467C19.1306 15.1466 19.131 15.1468 19.1308 15.1467L15.1129 12.412C14.78 12.1854 14.6865 11.7206 14.904 11.3739C15.1215 11.0271 15.5677 10.9297 15.9006 11.1563L19.92 13.8921C21.3189 14.8478 21.2688 17.0019 19.8238 17.8839L14.3767 21.2103C13.1997 21.9297 11.7404 21.9295 10.5629 21.2104L5.09705 17.8723C3.6598 16.9954 3.60137 14.8529 4.98686 13.8912L8.97865 11.1256C9.30976 10.8962 9.75666 10.9898 9.97688 11.3347Z"
      fill={color}
    />
  </svg>
);

export const UsersIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.519 12.1399H11.494C9.06528 12.1319 7.09728 10.0679 7.10304 7.53892C7.10304 5.00392 9.08448 2.94092 11.519 2.94092C13.9545 2.94092 15.936 5.00392 15.936 7.54092C15.936 10.0769 13.9545 12.1399 11.519 12.1399ZM11.519 4.44092C9.87836 4.44092 8.54304 5.83192 8.54304 7.54092C8.5392 9.24492 9.863 10.6339 11.496 10.6399H11.519C13.1606 10.6399 14.496 9.24992 14.496 7.54092C14.496 5.83192 13.1606 4.44092 11.519 4.44092ZM11.519 21.059C9.91484 21.059 5.0332 21.059 5.0332 17.857C5.0332 15.419 7.942 13.437 11.519 13.437C15.096 13.437 18.0048 15.413 18.0048 17.84C18.0048 21.059 13.1232 21.059 11.519 21.059ZM11.519 14.937C8.63128 14.937 6.4732 16.479 6.4732 17.857C6.4732 19.264 9.21784 19.559 11.519 19.559C13.8201 19.559 16.5648 19.261 16.5648 17.84C16.5648 16.47 14.4067 14.937 11.519 14.937ZM17.6538 11.0825C17.3351 11.0825 17.0442 10.8615 16.9578 10.5265C16.8551 10.1265 17.0836 9.7155 17.4676 9.6075C18.3671 9.3565 18.9959 8.5025 18.9959 7.5305C18.9959 6.5135 18.3047 5.6275 17.3505 5.4255C16.9607 5.3425 16.7102 4.9455 16.7889 4.5395C16.8695 4.1345 17.2477 3.8785 17.6385 3.9545C19.2599 4.2995 20.4359 5.8035 20.4359 7.5305C20.4359 9.1805 19.3684 10.6305 17.8401 11.0575C17.7777 11.0745 17.7143 11.0825 17.6538 11.0825ZM20.0833 17.977C19.7569 17.977 19.4622 17.745 19.3835 17.399C19.2923 16.996 19.5323 16.592 19.9192 16.497C20.3733 16.386 20.6142 15.984 20.6142 15.737C20.6142 15.209 19.6235 14.236 18.2123 14.236C17.8149 14.236 17.4923 13.9 17.4923 13.486C17.4923 13.072 17.8149 12.736 18.2123 12.736C20.2235 12.736 22.0542 14.166 22.0542 15.737C22.0542 16.75 21.2776 17.705 20.2494 17.957C20.1937 17.97 20.139 17.977 20.0833 17.977ZM5.38703 11.0825C5.32655 11.0825 5.26319 11.0745 5.20175 11.0575C3.67151 10.6315 2.60303 9.1815 2.60303 7.5305C2.60303 5.8035 3.77999 4.2995 5.40143 3.9545C5.79215 3.8785 6.17135 4.1345 6.25103 4.5395C6.32975 4.9455 6.07919 5.3425 5.68943 5.4255C4.73519 5.6275 4.04303 6.5135 4.04303 7.5305C4.04303 8.5025 4.67183 9.3565 5.57231 9.6075C5.95727 9.7155 6.18479 10.1265 6.08303 10.5255C5.99663 10.8615 5.70575 11.0825 5.38703 11.0825ZM2.95672 17.977C2.90104 17.977 2.84632 17.971 2.79064 17.957C1.76248 17.706 0.98584 16.75 0.98584 15.737C0.98584 14.166 2.81656 12.736 4.82776 12.736C5.2252 12.736 5.54776 13.072 5.54776 13.486C5.54776 13.9 5.2252 14.236 4.82776 14.236C3.41656 14.236 2.42584 15.209 2.42584 15.737C2.42584 15.984 2.6668 16.386 3.12088 16.497C3.50776 16.591 3.74776 16.996 3.65656 17.399C3.57784 17.745 3.28312 17.977 2.95672 17.977Z"
      fill={color}
    />
  </svg>
);

export const GuideIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.01314 9.96484C5.59706 9.96484 4.44922 11.113 4.44922 12.5278V17.6845C4.44922 19.1004 5.5972 20.2484 7.01314 20.2484H17.4871C18.9019 20.2484 20.05 19.1006 20.05 17.6845V12.5278C20.05 11.1128 18.9021 9.96484 17.4871 9.96484H7.01314ZM2.94922 12.5278C2.94922 10.2843 4.76892 8.46484 7.01314 8.46484H17.4871C19.7305 8.46484 21.55 10.2844 21.55 12.5278V17.6845C21.55 19.9287 19.7306 21.7484 17.4871 21.7484H7.01314C4.76878 21.7484 2.94922 19.9289 2.94922 17.6845V12.5278Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4091 13.7238C11.3127 14.5784 11.3101 15.5011 11.4098 16.4733C11.4293 16.6182 11.4844 16.6497 11.4927 16.6544C11.505 16.6613 11.5868 16.7009 11.7732 16.6282C12.5143 16.3292 13.1917 15.8875 13.7337 15.3975C13.8802 15.262 13.9031 15.1523 13.9028 15.0942C13.9025 15.0348 13.8772 14.9276 13.7361 14.7998L13.7328 14.7968C13.1643 14.276 12.5074 13.8676 11.766 13.564L11.7585 13.561C11.6176 13.5015 11.5323 13.5266 11.502 13.5425C11.4854 13.5512 11.4697 13.5641 11.4549 13.5861C11.4403 13.608 11.4194 13.6502 11.4091 13.7238ZM12.3379 12.1773C11.8416 11.969 11.2831 11.9635 10.8051 12.2142C10.3148 12.4714 9.99688 12.9532 9.92104 13.5349L9.91953 13.5473C9.80883 14.5229 9.8076 15.56 9.91871 16.6365L9.92048 16.652C9.98838 17.1983 10.2709 17.6879 10.7568 17.9615C11.2387 18.2328 11.8057 18.2274 12.3248 18.0231L12.3305 18.0209C13.2488 17.651 14.0774 17.1095 14.7427 16.5075L14.7471 16.5034C15.1564 16.127 15.4057 15.6303 15.4028 15.0864C15.4 14.5443 15.1472 14.0547 14.7445 13.6894C14.0377 13.0422 13.2291 12.5427 12.3379 12.1773Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.68164 6.11328C5.68164 5.69907 6.01743 5.36328 6.43164 5.36328H18.0683C18.4825 5.36328 18.8183 5.69907 18.8183 6.11328C18.8183 6.52749 18.4825 6.86328 18.0683 6.86328H6.43164C6.01743 6.86328 5.68164 6.52749 5.68164 6.11328Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21875 3C8.21875 2.58579 8.55454 2.25 8.96875 2.25H15.5304C15.9446 2.25 16.2804 2.58579 16.2804 3C16.2804 3.41421 15.9446 3.75 15.5304 3.75H8.96875C8.55454 3.75 8.21875 3.41421 8.21875 3Z"
      fill={color}
    />
  </svg>
);

export const ReportsIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.94745 4.35627C8.94745 4.02133 9.20792 3.75 9.52947 3.75H13.9903C14.3119 3.75 14.5724 4.02133 14.5724 4.35627V4.92933C14.5724 5.26428 14.3119 5.53561 13.9903 5.53561H9.52947C9.20792 5.53561 8.94745 5.26428 8.94745 4.92933V4.62805C8.94794 4.61668 8.94819 4.60525 8.94819 4.59375C8.94819 4.58225 8.94794 4.57082 8.94745 4.55945V4.35627ZM7.55544 3.89795C5.48683 4.23463 3.90381 6.09914 3.90381 8.34831V17.2458C3.90381 19.7334 5.84015 21.7504 8.22819 21.7504H15.2931C17.6811 21.7504 19.6175 19.7334 19.6175 17.2458V8.34831C19.6175 6.09857 18.0337 4.23369 15.9643 3.8977C15.7634 2.95488 14.956 2.25 13.9903 2.25H9.52947C8.56374 2.25 7.75627 2.95501 7.55544 3.89795ZM15.9564 5.4236C15.7429 6.34846 14.9438 7.03561 13.9903 7.03561H9.52947C8.57617 7.03561 7.77708 6.34864 7.5635 5.42395C6.29107 5.73669 5.34381 6.92748 5.34381 8.34831V17.2458C5.34381 18.9049 6.63543 20.2504 8.22819 20.2504H15.2931C16.8859 20.2504 18.1775 18.9049 18.1775 17.2458V8.34831C18.1775 6.92695 17.2295 5.7358 15.9564 5.4236ZM10.6138 14.3837C10.895 14.6766 10.895 15.1515 10.6138 15.4444L9.19043 16.9271C8.90926 17.22 8.45337 17.22 8.1722 16.9271L7.44086 16.1653C7.15969 15.8724 7.15969 15.3976 7.44086 15.1047C7.72204 14.8118 8.17792 14.8118 8.4591 15.1047L8.68132 15.3362L9.59564 14.3837C9.87684 14.0908 10.3327 14.0908 10.6138 14.3837ZM10.6138 10.5967C10.895 10.3038 10.895 9.82897 10.6138 9.53608C10.3327 9.24318 9.87684 9.24318 9.59564 9.53608L8.68132 10.4885L8.4591 10.257C8.17792 9.96413 7.72204 9.96413 7.44086 10.257C7.15969 10.5499 7.15969 11.0248 7.44086 11.3177L8.1722 12.0795C8.45337 12.3724 8.90926 12.3724 9.19043 12.0795L10.6138 10.5967ZM11.8856 16.2891C11.8856 15.8748 12.2079 15.5391 12.6056 15.5391H15.5692C15.9669 15.5391 16.2892 15.8748 16.2892 16.2891C16.2892 16.7033 15.9669 17.0391 15.5692 17.0391H12.6056C12.2079 17.0391 11.8856 16.7033 11.8856 16.2891ZM12.6056 10.6914C12.2079 10.6914 11.8856 11.0272 11.8856 11.4414C11.8856 11.8556 12.2079 12.1914 12.6056 12.1914H15.5692C15.9669 12.1914 16.2892 11.8556 16.2892 11.4414C16.2892 11.0272 15.9669 10.6914 15.5692 10.6914H12.6056Z"
      fill={color}
    />
  </svg>
);

export const EyeIcon = ({
  color = DEFAULT_COLOR,
  width = "20px",
  height = "20px",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20" // Keep this static to match the coordinate system
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2102_5916)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1338 11.0455C3.82714 14.9872 6.84464 17.343 10.2055 17.343H10.2105C13.5705 17.3405 16.588 14.9872 18.2822 11.0455C18.316 10.9675 18.3334 10.8834 18.3334 10.7984C18.3334 10.7134 18.316 10.6292 18.2822 10.5513C16.5872 6.60881 13.5663 4.25464 10.2063 4.25464C6.84631 4.25464 3.8288 6.60881 2.1338 10.5513C2.09998 10.6292 2.08252 10.7134 2.08252 10.7984C2.08252 10.8834 2.09998 10.9675 2.1338 11.0455ZM10.2038 16.093C7.42548 16.0922 4.89214 14.1188 3.38714 10.7988H3.38881C4.89464 7.47797 7.42381 5.50464 10.2022 5.50464C12.9805 5.50464 15.5138 7.47797 17.0205 10.7988C15.5147 14.1188 12.9822 16.0938 10.2038 16.093ZM8.43433 13.4532C8.95866 13.8037 9.57508 13.9907 10.2057 13.9907C11.0508 13.9896 11.8611 13.6534 12.4587 13.0559C13.0564 12.4584 13.3927 11.6483 13.3941 10.8032C13.3942 10.1726 13.2074 9.556 12.8572 9.03158C12.5069 8.50716 12.009 8.09839 11.4264 7.85695C10.8438 7.6155 10.2027 7.55225 9.58425 7.67518C8.96575 7.79811 8.3975 8.1017 7.95156 8.54758C7.50557 8.99341 7.20183 9.5615 7.07874 10.18C6.95565 10.7985 7.01875 11.4397 7.26004 12.0222C7.50133 12.6049 7.90998 13.1029 8.43433 13.4532ZM9.129 9.19058C9.44766 8.97766 9.82241 8.864 10.2057 8.864C10.7197 8.86491 11.2123 9.0695 11.5757 9.433C11.939 9.7965 12.1434 10.2892 12.1441 10.8032C12.1439 11.1865 12.0301 11.5612 11.817 11.8798C11.6039 12.1985 11.3012 12.4467 10.9469 12.5933C10.5927 12.7399 10.203 12.7782 9.82708 12.7033C9.45116 12.6284 9.10583 12.4437 8.83483 12.1727C8.56383 11.9016 8.37933 11.5562 8.30461 11.1802C8.22988 10.8042 8.26831 10.4145 8.415 10.0604C8.56175 9.70625 8.81025 9.40358 9.129 9.19058Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2102_5916">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EyeSlashIcon = ({ color = DEFAULT_COLOR }) => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none">
    <defs>
      <clipPath id="clip0_2102_5916">
        <rect id="svg_1" fill="white" height="20" width="20" />
      </clipPath>
    </defs>
    <g>
      <title>Layer 1</title>
      <g id="svg_2" clipPath="url(#clip0_2102_5916)">
        <path
          id="svg_3"
          fill={color}
          d="m2.1338,11.0455c1.69334,3.9417 4.71084,6.2975 8.0717,6.2975l0.005,0c3.36,-0.0025 6.3775,-2.3558 8.0717,-6.2975c0.0338,-0.078 0.0512,-0.1621 0.0512,-0.2471c0,-0.085 -0.0174,-0.1692 -0.0512,-0.2471c-1.695,-3.94249 -4.7159,-6.29666 -8.0759,-6.29666c-3.35999,0 -6.3775,2.35417 -8.0725,6.29666c-0.03382,0.0779 -0.05128,0.1621 -0.05128,0.2471c0,0.085 0.01746,0.1691 0.05128,0.2471zm8.07,5.0475c-2.77832,-0.0008 -5.31166,-1.9742 -6.81666,-5.2942l0.00167,0c1.50583,-3.32083 4.035,-5.29416 6.81339,-5.29416c2.7783,0 5.3116,1.97333 6.8183,5.29416c-1.5058,3.32 -4.0383,5.295 -6.8167,5.2942zm-1.76947,-2.6398c0.52433,0.3505 1.14075,0.5375 1.77137,0.5375c0.8451,-0.0011 1.6554,-0.3373 2.253,-0.9348c0.5977,-0.5975 0.934,-1.4076 0.9354,-2.2527c0.0001,-0.6306 -0.1867,-1.2472 -0.5369,-1.77162c-0.3503,-0.52442 -0.8482,-0.93319 -1.4308,-1.17463c-0.5826,-0.24145 -1.2237,-0.3047 -1.84215,-0.18177c-0.6185,0.12293 -1.18675,0.42652 -1.63269,0.8724c-0.44599,0.44583 -0.74973,1.01392 -0.87282,1.63242c-0.12309,0.6185 -0.05999,1.2597 0.1813,1.8422c0.24129,0.5827 0.64994,1.0807 1.17429,1.431zm0.69467,-4.26262c0.31866,-0.21292 0.69341,-0.32658 1.0767,-0.32658c0.514,0.00091 1.0066,0.2055 1.37,0.569c0.3633,0.3635 0.5677,0.8562 0.5684,1.3702c-0.0002,0.3833 -0.114,0.758 -0.3271,1.0766c-0.2131,0.3187 -0.5158,0.5669 -0.8701,0.7135c-0.3542,0.1466 -0.7439,0.1849 -1.11982,0.11c-0.37592,-0.0749 -0.72125,-0.2596 -0.99225,-0.5306c-0.271,-0.2711 -0.4555,-0.6165 -0.53022,-0.9925c-0.07473,-0.376 -0.0363,-0.7657 0.11039,-1.1198c0.14675,-0.35415 0.39525,-0.65682 0.714,-0.86982z"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </g>
      <line
        strokeLinecap="undefined"
        strokeLinejoin="undefined"
        id="svg_4"
        y2="18.49999"
        x2="5.25"
        y1="2.49999"
        x1="15.25"
        stroke="#000"
        fill="none"
      />
    </g>
  </svg>
);

export const NoteIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2167_259"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2167_259)"></g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.78692 2.29169C4.78692 1.94651 4.5071 1.66669 4.16192 1.66669C3.81675 1.66669 3.53692 1.94651 3.53692 2.29169V3.53775H2.29166C1.94648 3.53775 1.66666 3.81757 1.66666 4.16275C1.66666 4.50793 1.94648 4.78775 2.29166 4.78775H3.53692V6.0328C3.53692 6.37799 3.81675 6.6578 4.16192 6.6578C4.5071 6.6578 4.78692 6.37799 4.78692 6.0328V4.78775H6.03277C6.37795 4.78775 6.65777 4.50793 6.65777 4.16275C6.65777 3.81757 6.37795 3.53775 6.03277 3.53775H4.78692V2.29169ZM8.49932 2.39911C8.15416 2.39911 7.87435 2.67893 7.87435 3.02411C7.87435 3.36928 8.15416 3.64911 8.49932 3.64911H13.5451C14.5458 3.64911 15.3101 3.99783 15.8273 4.55327C16.3493 5.11374 16.6669 5.93628 16.6669 6.96063V11.3998L14.6975 11.3997L14.696 11.3998C13.0468 11.4039 11.7114 12.7433 11.7122 14.3925V16.4976H6.93933C5.94317 16.4976 5.17872 16.1492 4.66027 15.5931C4.13729 15.0321 3.81835 14.2093 3.81835 13.1853V8.52147C3.81835 8.1763 3.53852 7.89646 3.19335 7.89646C2.84817 7.89646 2.56835 8.1763 2.56835 8.52147V13.1853C2.56835 14.4689 2.97144 15.6147 3.74597 16.4455C4.52503 17.2811 5.63357 17.7476 6.93933 17.7476H11.8918C12.5781 17.7476 13.2346 17.467 13.7097 16.9725L17.2152 13.3211C17.6645 12.8524 17.9169 12.2273 17.9169 11.5766V6.96063C17.9169 5.67822 17.5161 4.53248 16.7421 3.70139C15.9635 2.86527 14.8544 2.39911 13.5451 2.39911H8.49932ZM12.9622 15.9461L16.1268 12.6498H14.6983C13.7388 12.6525 12.9616 13.4323 12.9622 14.392V15.9461ZM6.42371 7.86135C6.42371 7.51617 6.70352 7.23635 7.04871 7.23635H12.0872C12.4323 7.23635 12.7122 7.51617 12.7122 7.86135C12.7122 8.20655 12.4323 8.48638 12.0872 8.48638H7.04871C6.70352 8.48638 6.42371 8.20655 6.42371 7.86135ZM6.42252 11.5995C6.42252 11.2543 6.70234 10.9745 7.04752 10.9745H10.1789C10.5241 10.9745 10.8039 11.2543 10.8039 11.5995C10.8039 11.9447 10.5241 12.2245 10.1789 12.2245H7.04752C6.70234 12.2245 6.42252 11.9447 6.42252 11.5995Z"
      fill={color}
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2212_7154)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 16.7617C11.3055 16.7617 10.7385 17.3267 10.7385 18.0227C10.7385 18.7177 11.3055 19.2827 12.0005 19.2827C12.6955 19.2827 13.2615 18.7177 13.2615 18.0227C13.2615 17.3267 12.6955 16.7617 12.0005 16.7617Z"
        fill="#6C757D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 10.7402C11.3055 10.7402 10.7385 11.3052 10.7385 12.0012C10.7385 12.6962 11.3055 13.2612 12.0005 13.2612C12.6955 13.2612 13.2615 12.6962 13.2615 12.0012C13.2615 11.3052 12.6955 10.7402 12.0005 10.7402Z"
        fill="#6C757D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 7.23975C12.6955 7.23975 13.2615 6.67475 13.2615 5.97875C13.2615 5.28375 12.6955 4.71875 12.0005 4.71875C11.3055 4.71875 10.7385 5.28375 10.7385 5.97875C10.7385 6.67475 11.3055 7.23975 12.0005 7.23975Z"
        fill="#6C757D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2212_7154">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78249 1.66675C14.2575 1.66675 17.8975 5.30675 17.8975 9.78175C17.8975 11.893 17.0873 13.8186 15.7614 15.2638L18.3703 17.8673C18.6145 18.1115 18.6153 18.5065 18.3712 18.7507C18.2495 18.874 18.0887 18.9348 17.9287 18.9348C17.7695 18.9348 17.6095 18.874 17.487 18.7523L14.8465 16.1193C13.4576 17.2316 11.6964 17.8976 9.78249 17.8976C5.30749 17.8976 1.66666 14.2567 1.66666 9.78175C1.66666 5.30675 5.30749 1.66675 9.78249 1.66675ZM9.78249 2.91675C5.99666 2.91675 2.91666 5.99591 2.91666 9.78175C2.91666 13.5676 5.99666 16.6476 9.78249 16.6476C13.5675 16.6476 16.6475 13.5676 16.6475 9.78175C16.6475 5.99591 13.5675 2.91675 9.78249 2.91675Z"
      fill="#6C757D"
    />
  </svg>
);

export const DownArrowIcon = ({
  width = 20,
  height = 20,
  fill = "#6C757D",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.46967 7.96967C4.73594 7.7034 5.1526 7.6792 5.44621 7.89705L5.53033 7.96967L12 14.439L18.4697 7.96967C18.7359 7.7034 19.1526 7.6792 19.4462 7.89705L19.5303 7.96967C19.7966 8.23594 19.8208 8.6526 19.6029 8.94621L19.5303 9.03033L12.5303 16.0303C12.2641 16.2966 11.8474 16.3208 11.5538 16.1029L11.4697 16.0303L4.46967 9.03033C4.17678 8.73744 4.17678 8.26256 4.46967 7.96967Z"
      fill={fill}
    />
  </svg>
);

export const SortArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_125_3656)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22473 12.0581C6.4688 11.814 6.86454 11.814 7.10861 12.0581L10 14.9494L12.8914 12.0581C13.1355 11.814 13.5312 11.814 13.7753 12.0581C14.0193 12.3021 14.0193 12.6978 13.7753 12.9419L10.4419 16.2752C10.1978 16.5193 9.80217 16.5193 9.55809 16.2752L6.22473 12.9419C5.98065 12.6978 5.98065 12.3021 6.22473 12.0581Z"
        fill="#495057"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55809 3.7248C9.80217 3.48073 10.1978 3.48073 10.4419 3.7248L13.7753 7.05814C14.0193 7.30221 14.0193 7.69795 13.7753 7.94202C13.5312 8.1861 13.1355 8.1861 12.8914 7.94202L10 5.05063L7.10861 7.94202C6.86454 8.1861 6.4688 8.1861 6.22473 7.94202C5.98065 7.69795 5.98065 7.30221 6.22473 7.05814L9.55809 3.7248Z"
        fill="#495057"
      />
    </g>
    <defs>
      <clipPath id="clip0_125_3656">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SyncIcon = ({ color = "#004F96" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3014_9966)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0829 3.74072C7.6259 3.14261 4.33854 5.46024 3.74043 8.91733C3.45515 10.5662 3.83277 12.1764 4.68212 13.4753L4.92787 12.4123C5.00561 12.076 5.34127 11.8664 5.67758 11.9441C6.01388 12.0219 6.22349 12.3576 6.14574 12.6939L5.57814 15.1491C5.54081 15.3106 5.44084 15.4507 5.30024 15.5385C5.15964 15.6263 4.98992 15.6546 4.82842 15.6173L2.35935 15.0465C2.02305 14.9687 1.81345 14.6331 1.8912 14.2967C1.96896 13.9605 2.30462 13.7508 2.64093 13.8286L3.56022 14.0411C2.59809 12.5087 2.17582 10.6284 2.50873 8.70416C3.22453 4.56689 7.15875 1.79321 11.2961 2.50902C11.6362 2.56786 11.8642 2.89129 11.8053 3.23142C11.7465 3.57154 11.4231 3.79957 11.0829 3.74072ZM15.1714 4.38154C15.0099 4.3442 14.8402 4.37255 14.6996 4.46035C14.559 4.54815 14.459 4.6882 14.4217 4.84971L13.8541 7.30499C13.7763 7.64129 13.9859 7.97695 14.3223 8.0547C14.6586 8.13244 14.9943 7.92284 15.072 7.58654L15.3176 6.5244C16.1673 7.82349 16.5451 9.43405 16.2598 11.0832C15.6617 14.5403 12.3743 16.8579 8.91725 16.2598C8.57716 16.201 8.25372 16.429 8.19488 16.7692C8.13603 17.1092 8.36408 17.4327 8.70416 17.4915C12.8415 18.2073 16.7757 15.4337 17.4915 11.2963C17.8246 9.37134 17.4018 7.49026 16.4388 5.95752L17.3589 6.17026C17.6953 6.24802 18.0309 6.03842 18.1087 5.70211C18.1864 5.3658 17.9768 5.03014 17.6405 4.95239L15.1714 4.38154Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3014_9966">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinedRightArrow = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3004_4019)">
      <path
        d="M3.33325 9.77149C3.33325 9.45508 3.56838 9.19358 3.87344 9.1522L3.95825 9.14649L14.9449 9.14699L10.9758 5.19405C10.7312 4.9505 10.7303 4.55477 10.9739 4.31017C11.1953 4.0878 11.5424 4.06688 11.7875 4.2479L11.8577 4.30827L16.8994 9.32827C16.9317 9.36037 16.9597 9.39512 16.9834 9.43181C16.9901 9.44285 16.997 9.45415 17.0034 9.46568C17.0094 9.47556 17.0148 9.48582 17.0199 9.49619C17.0269 9.51128 17.0338 9.52687 17.0401 9.54278C17.0452 9.55504 17.0494 9.56697 17.0533 9.579C17.0579 9.59391 17.0624 9.6098 17.0662 9.62593C17.0691 9.6372 17.0713 9.64804 17.0733 9.65892C17.0761 9.67511 17.0785 9.69187 17.0801 9.70883C17.0816 9.72176 17.0825 9.73457 17.083 9.7474C17.0831 9.75517 17.0833 9.76331 17.0833 9.77149L17.0829 9.7957C17.0825 9.80797 17.0816 9.82023 17.0804 9.83245L17.0833 9.77149C17.0833 9.81093 17.0796 9.84952 17.0726 9.88693C17.071 9.89587 17.0691 9.90504 17.0669 9.91418C17.0625 9.93299 17.0574 9.95111 17.0514 9.96887C17.0485 9.9777 17.0452 9.98713 17.0416 9.99649C17.0343 10.0153 17.0263 10.0332 17.0176 10.0507C17.0135 10.0589 17.009 10.0675 17.0042 10.076C16.9964 10.0899 16.9884 10.1031 16.9799 10.1159C16.9739 10.125 16.9672 10.1345 16.9603 10.1438L16.9549 10.151C16.938 10.173 16.9198 10.1939 16.9002 10.2134L16.8994 10.214L11.8578 15.2348C11.6132 15.4784 11.2175 15.4776 10.9739 15.233C10.7525 15.0107 10.733 14.6634 10.9151 14.4191L10.9757 14.3491L14.9433 10.397L3.95825 10.3965C3.61307 10.3965 3.33325 10.1167 3.33325 9.77149Z"
        fill="#004F96"
      />
    </g>
    <defs>
      <clipPath id="clip0_3004_4019">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InfoFilled = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2229_970"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2229_970)"></g>
    <g clipPath="url(#clip0_2229_970)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50402 10.4621C8.50402 10.7381 8.28002 10.9621 8.00402 10.9621C7.72802 10.9621 7.50402 10.7381 7.50402 10.4621V7.59608C7.50402 7.32008 7.72802 7.09608 8.00402 7.09608C8.28002 7.09608 8.50402 7.32008 8.50402 7.59608V10.4621ZM7.50002 5.52741C7.50002 5.25141 7.72402 5.02741 8.00002 5.02741C8.27602 5.02741 8.50002 5.25141 8.50002 5.52741C8.50002 5.80341 8.27602 6.04875 8.00002 6.04875C7.72402 6.04875 7.50002 5.84541 7.50002 5.56941V5.52741ZM8.00002 1.66675C4.50802 1.66675 1.66669 4.50741 1.66669 8.00008C1.66669 11.4921 4.50802 14.3334 8.00002 14.3334C11.492 14.3334 14.3334 11.4921 14.3334 8.00008C14.3334 4.50741 11.492 1.66675 8.00002 1.66675Z"
        fill="#196E74"
      />
    </g>
    <defs>
      <clipPath id="clip0_2229_970">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LeftNavigationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3586 3.51655C13.5805 3.73844 13.6007 4.08566 13.4191 4.33034L13.3586 4.40044L7.96752 9.79183L13.3586 15.1832C13.5805 15.4051 13.6007 15.7523 13.4191 15.997L13.3586 16.0671C13.1367 16.289 12.7895 16.3092 12.5448 16.1276L12.4747 16.0671L6.64141 10.2338C6.41952 10.0119 6.39935 9.66466 6.5809 9.41999L6.64141 9.34989L12.4747 3.51655C12.7188 3.27248 13.1146 3.27248 13.3586 3.51655Z"
      fill="#ADB5BD"
    />
  </svg>
);

export const RightNavigationIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.64139 16.2749C6.4195 16.0531 6.39933 15.7058 6.58088 15.4612L6.64139 15.3911L12.0325 9.99967L6.64139 4.60828C6.4195 4.38639 6.39933 4.03917 6.58088 3.7945L6.64139 3.7244C6.86328 3.50251 7.2105 3.48234 7.45518 3.66388L7.52528 3.7244L13.3586 9.55773C13.5805 9.77962 13.6007 10.1268 13.4191 10.3715L13.3586 10.4416L7.52528 16.2749C7.2812 16.519 6.88547 16.519 6.64139 16.2749Z"
      fill={color}
    />
  </svg>
);

// Edit Line/Edit
export const EditIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2921 15.033C16.6371 15.033 16.9171 15.313 16.9171 15.658C16.9171 16.003 16.6371 16.283 16.2921 16.283H10.2479C9.90292 16.283 9.62292 16.003 9.62292 15.658C9.62292 15.313 9.90292 15.033 10.2479 15.033H16.2921ZM12.4302 1.0447C12.4719 1.0772 13.8661 2.16054 13.8661 2.16054C14.3727 2.4622 14.7686 3.00137 14.9186 3.6397C15.0677 4.27137 14.9594 4.92304 14.6119 5.47387C14.6096 5.47754 14.6073 5.48117 14.5992 5.49197L14.593 5.50032C14.5366 5.57465 14.2914 5.8847 13.0538 7.43519C13.0423 7.45551 13.0293 7.47454 13.0151 7.49304C12.9942 7.5203 12.9715 7.54535 12.9473 7.56817C12.8628 7.67445 12.7737 7.78612 12.68 7.90353L12.49 8.14142C12.0981 8.63223 11.6332 9.21424 11.0817 9.90455L10.7987 10.2588C9.73398 11.5914 8.37038 13.2977 6.62358 15.483C6.24108 15.9597 5.66775 16.2372 5.05192 16.2447L2.01942 16.283H2.01108C1.72192 16.283 1.47025 16.0847 1.40275 15.8022L0.720249 12.9097C0.579416 12.3105 0.719416 11.6922 1.10358 11.2122L8.95358 1.39387C8.95692 1.39054 8.95942 1.38637 8.96275 1.38304C9.82358 0.353869 11.3802 0.202202 12.4302 1.0447ZM8.07835 4.48917L2.07942 11.993C1.93692 12.1714 1.88442 12.4014 1.93692 12.6222L2.50442 15.0264L5.03692 14.9947C5.27775 14.9922 5.50025 14.8847 5.64775 14.7014C6.40732 13.751 7.36196 12.5566 8.34346 11.3284L8.69071 10.8938L9.03855 10.4585C9.95904 9.30657 10.8684 8.16839 11.6293 7.21572L8.07835 4.48917ZM9.92525 2.18054L8.85919 3.5125L12.4098 6.23827C13.0933 5.38225 13.5429 4.81845 13.5844 4.7647C13.7211 4.54304 13.7744 4.2297 13.7027 3.92804C13.6294 3.61887 13.4369 3.35637 13.1594 3.18887C13.1002 3.14804 11.6961 2.05804 11.6527 2.02387C11.1244 1.60054 10.3536 1.67387 9.92525 2.18054Z"
      fill={color}
    />
  </svg>
);

export const AddUserIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2278_4420)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.95465 3.75659C7.13641 3.75659 5.66241 5.23059 5.66241 7.04886C5.66241 8.86708 7.13641 10.3411 8.95465 10.3411C10.773 10.3411 12.247 8.86708 12.247 7.04886C12.247 5.23059 10.773 3.75659 8.95465 3.75659ZM4.41241 7.04886C4.41241 4.54023 6.44606 2.50659 8.95465 2.50659C11.4633 2.50659 13.497 4.54023 13.497 7.04886C13.497 9.5575 11.4633 11.5911 8.95465 11.5911C6.44606 11.5911 4.41241 9.5575 4.41241 7.04886Z"
        fill="#6C757D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92956 14.8668C2.92956 12.4972 4.85056 10.5762 7.22021 10.5762H10.7897C11.6198 10.5762 12.3967 10.8126 13.0544 11.2219C13.3474 11.4043 13.4371 11.7898 13.2547 12.0828C13.0723 12.3759 12.6869 12.4656 12.3938 12.2832C11.9286 11.9936 11.3796 11.8262 10.7897 11.8262H7.22021C5.54091 11.8262 4.17956 13.1875 4.17956 14.8668C4.17956 15.0127 4.17746 15.15 4.17546 15.2811C4.16928 15.6865 4.16401 16.0314 4.22456 16.3801C4.28363 16.7202 4.05582 17.0438 3.71574 17.1028C3.37565 17.1618 3.05207 16.9341 2.993 16.594C2.91025 16.1175 2.91871 15.6129 2.92587 15.1865C2.92776 15.0738 2.92956 14.9666 2.92956 14.8668Z"
        fill="#6C757D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9968 11.9939C15.3419 11.9939 15.6218 12.2737 15.6218 12.6189V14.1171H17.0795C17.4247 14.1171 17.7045 14.3969 17.7045 14.7421C17.7045 15.0872 17.4247 15.3671 17.0795 15.3671H15.6218V16.8671C15.6218 17.2123 15.3419 17.4921 14.9968 17.4921C14.6516 17.4921 14.3718 17.2123 14.3718 16.8671V15.3671H12.9151C12.5699 15.3671 12.2901 15.0872 12.2901 14.7421C12.2901 14.3969 12.5699 14.1171 12.9151 14.1171H14.3718V12.6189C14.3718 12.2737 14.6516 11.9939 14.9968 11.9939Z"
        fill="#6C757D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2278_4420">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PublishIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6466 1.66699C11.6825 1.66699 11.7176 1.67002 11.7518 1.67583L11.8644 1.67649C12.0344 1.67649 12.1969 1.74566 12.3153 1.86816L16.5369 6.26566C16.6478 6.38149 16.7103 6.53733 16.7103 6.69816V14.3565C16.7236 16.4473 15.0936 18.1465 12.9994 18.2215H6.2161C4.18257 18.1778 2.55169 16.5345 2.5014 14.5217L2.5011 5.40899C2.55027 3.34149 4.25693 1.67649 6.3086 1.67649L11.5414 1.67583C11.5756 1.67002 11.6107 1.66699 11.6466 1.66699ZM11.0211 2.92616L6.3111 2.92649C4.93027 2.92649 3.7836 4.04483 3.7511 5.42399V14.3565C3.7211 15.774 4.83777 16.9407 6.24193 16.9715H12.9778C14.3686 16.9215 15.4694 15.774 15.4603 14.3607L15.4603 7.48616L13.7866 7.48699C12.2608 7.48283 11.0216 6.23949 11.0216 4.71616L11.0211 2.92616ZM9.28477 7.63274C9.45726 7.63274 9.61352 7.70274 9.72664 7.81587L9.72752 7.81641L11.6825 9.77974C11.9258 10.0247 11.925 10.4197 11.6808 10.6631C11.4358 10.9064 11.04 10.9064 10.7967 10.6614L9.90943 9.77033L9.90977 13.2919C9.90977 13.6369 9.62977 13.9169 9.28477 13.9169C8.93976 13.9169 8.65977 13.6369 8.65977 13.2919L8.65943 9.77033L7.77335 10.6614C7.65168 10.7847 7.49085 10.8456 7.33085 10.8456C7.17168 10.8456 7.01168 10.7847 6.89002 10.6631C6.64585 10.4197 6.64418 10.0247 6.88835 9.77974L8.84168 7.81641L8.86956 7.79071C8.88161 7.77998 8.89408 7.76972 8.90695 7.75994L8.84168 7.81641C8.86492 7.79309 8.88994 7.77207 8.91639 7.75336C9.0193 7.6775 9.14684 7.63274 9.28477 7.63274ZM12.2711 3.62699L12.2716 4.71616C12.2716 5.55283 12.9516 6.23449 13.7883 6.23699L14.7753 6.23616L12.2711 3.62699Z"
      fill={color}
    />
  </svg>
);

export const ExportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.89935 1.66675C10.2445 1.66675 10.5244 1.94657 10.5244 2.29175V12.3259C10.5244 12.6711 10.2445 12.9509 9.89935 12.9509C9.5541 12.9509 9.27435 12.6711 9.27435 12.3259V2.29175C9.27435 1.94657 9.5541 1.66675 9.89935 1.66675Z"
      fill="#6C757D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.02826 9.44411C7.27284 9.20053 7.66857 9.20136 7.91214 9.44594L9.89927 11.4413L11.8864 9.44594C12.13 9.20136 12.5258 9.20053 12.7704 9.44411C13.0149 9.68769 13.0157 10.0834 12.7722 10.3279L10.3422 12.7679C10.2249 12.8858 10.0655 12.9519 9.89927 12.9519C9.7331 12.9519 9.57377 12.8858 9.45644 12.7679L7.02645 10.3279C6.78288 10.0834 6.78369 9.68769 7.02826 9.44411Z"
      fill="#6C757D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0195 5.99148C13.0512 5.64777 13.3555 5.39482 13.6993 5.42651C15.2387 5.56845 16.4878 5.94072 17.2958 7.03089C18.0704 8.07614 18.3335 9.65097 18.3335 11.8822C18.3335 14.8401 17.8695 16.6586 16.3499 17.5919C15.6257 18.0366 14.7288 18.2332 13.702 18.3287C12.6793 18.4239 11.4508 18.4239 10.0266 18.4239H9.97384C8.54917 18.4239 7.32044 18.4239 6.2977 18.3287C5.27092 18.2332 4.37403 18.0366 3.64986 17.5919C2.13043 16.6586 1.66687 14.84 1.66687 11.8822C1.66687 9.65105 1.92975 8.07619 2.7043 7.03093C3.51217 5.9407 4.76141 5.56844 6.30117 5.42651C6.6449 5.39483 6.94922 5.64778 6.9809 5.9915C7.01259 6.33523 6.75963 6.63955 6.41591 6.67123C4.97233 6.8043 4.18825 7.12788 3.70862 7.77514C3.19566 8.46738 2.91687 9.67172 2.91687 11.8822C2.91687 14.8411 3.4154 15.9809 4.3041 16.5267C4.784 16.8215 5.45267 16.9947 6.41348 17.0841C7.37201 17.1733 8.544 17.1739 10.0002 17.1739C11.456 17.1739 12.6278 17.1733 13.5863 17.0841C14.5469 16.9947 15.2157 16.8215 15.6958 16.5267C16.5847 15.9808 17.0835 14.841 17.0835 11.8822C17.0835 9.6718 16.8046 8.46747 16.2915 7.77518C15.8118 7.12786 15.0276 6.80429 13.5845 6.67123C13.2408 6.63954 12.9878 6.33521 13.0195 5.99148Z"
      fill="#6C757D"
    />
  </svg>
);

export const ExportUpIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="rotate(180 12 8)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8792 2C12.2934 2 12.6292 2.33579 12.6292 2.75V14.791C12.6292 15.2052 12.2934 15.541 11.8792 15.541C11.4649 15.541 11.1292 15.2052 11.1292 14.791V2.75C11.1292 2.33579 11.4649 2 11.8792 2Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43389 11.3328C8.72739 11.0405 9.20226 11.0415 9.49455 11.335L11.8791 13.7294L14.2637 11.335C14.556 11.0415 15.0309 11.0405 15.3244 11.3328C15.6179 11.6251 15.6188 12.0999 15.3266 12.3934L12.4106 15.3214C12.2698 15.4628 12.0786 15.5422 11.8791 15.5422C11.6797 15.5422 11.4885 15.4628 11.3477 15.3214L8.43172 12.3934C8.13943 12.0999 8.1404 11.6251 8.43389 11.3328Z"
        fill={color}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6234 7.18985C15.6614 6.77739 16.0266 6.47385 16.4391 6.51188C18.2864 6.68221 19.7854 7.12893 20.7549 8.43714C21.6845 9.69144 22.0002 11.5812 22.0002 14.2587C22.0002 17.8081 21.4434 19.9904 19.6199 21.1103C18.7508 21.644 17.6745 21.8799 16.4424 21.9945C15.2152 22.1087 13.741 22.1087 12.0319 22.1087H11.9686C10.259 22.1087 8.78452 22.1087 7.55723 21.9945C6.3251 21.8799 5.24883 21.644 4.37983 21.1103C2.55651 19.9903 2.00024 17.808 2.00024 14.2587C2.00024 11.5813 2.3157 9.6915 3.24515 8.43719C4.2146 7.12891 5.71369 6.6822 7.5614 6.51188C7.97387 6.47386 8.33906 6.77741 8.37708 7.18987C8.4151 7.60234 8.11155 7.96753 7.69909 8.00555C5.96679 8.16523 5.02589 8.55352 4.45034 9.33024C3.83479 10.1609 3.50024 11.6061 3.50024 14.2587C3.50024 17.8094 4.09847 19.1771 5.16491 19.8321C5.74079 20.1858 6.5432 20.3937 7.69617 20.501C8.84641 20.608 10.2528 20.6087 12.0002 20.6087C13.7472 20.6087 15.1533 20.608 16.3035 20.501C17.4563 20.3937 18.2588 20.1858 18.8349 19.8321C19.9016 19.177 20.5002 17.8092 20.5002 14.2587C20.5002 11.6062 20.1655 10.161 19.5498 9.33029C18.9741 8.5535 18.0331 8.16522 16.3014 8.00555C15.8889 7.96752 15.5854 7.60232 15.6234 7.18985Z"
      fill={color}
    />
  </svg>
);

export const LogIcon = ({
  color = DEFAULT_COLOR,
  width = "20px",
  height = "20px",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.27214 3.125C7.99301 3.125 7.76691 3.35111 7.76691 3.63022V4.10777C7.76691 4.3869 7.99301 4.61301 8.27214 4.61301H12.1444C12.4236 4.61301 12.6496 4.3869 12.6496 4.10777V3.63022C12.6496 3.35111 12.4236 3.125 12.1444 3.125H8.27214ZM6.51691 3.63022C6.51691 2.66075 7.30266 1.875 8.27214 1.875H12.1444C13.1139 1.875 13.8996 2.66075 13.8996 3.63022V4.10777C13.8996 5.07726 13.1139 5.86301 12.1444 5.86301H8.27214C7.30266 5.86301 6.51691 5.07726 6.51691 4.10777V3.63022Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14247 4.45312C5.75987 4.45312 4.63867 5.57433 4.63867 6.95693V14.3715C4.63867 15.7541 5.75987 16.8753 7.14247 16.8753H13.2752C14.6578 16.8753 15.779 15.7541 15.779 14.3715V6.95693C15.779 5.57433 14.6578 4.45312 13.2752 4.45312C12.93 4.45312 12.6502 4.1733 12.6502 3.82812C12.6502 3.48295 12.93 3.20312 13.2752 3.20312C15.3482 3.20312 17.029 4.88398 17.029 6.95693V14.3715C17.029 16.4445 15.3482 18.1253 13.2752 18.1253H7.14247C5.06952 18.1253 3.38867 16.4445 3.38867 14.3715V6.95693C3.38867 4.88398 5.06952 3.20312 7.14247 3.20312C7.48765 3.20312 7.76747 3.48295 7.76747 3.82812C7.76747 4.1733 7.48765 4.45312 7.14247 4.45312Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.06866 9.12769C7.06866 8.78252 7.34849 8.50269 7.69366 8.50269H12.7221C13.0673 8.50269 13.3471 8.78252 13.3471 9.12769C13.3471 9.47285 13.0673 9.75269 12.7221 9.75269H7.69366C7.34849 9.75269 7.06866 9.47285 7.06866 9.12769ZM7.06866 12.8634C7.06866 12.5181 7.34849 12.2384 7.69366 12.2384H12.7221C13.0673 12.2384 13.3471 12.5181 13.3471 12.8634C13.3471 13.2085 13.0673 13.4884 12.7221 13.4884H7.69366C7.34849 13.4884 7.06866 13.2085 7.06866 12.8634Z"
      fill={color}
    />
  </svg>
);

export const DeleteIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Left Icon">
      <path
        id="Delete"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29812 1.66675H11.7315C12.4843 1.66675 13.145 2.17273 13.3398 2.90134C13.343 2.91358 13.346 2.92593 13.3485 2.93835L13.6661 4.50203H16.8996C17.2448 4.50203 17.5246 4.78186 17.5246 5.12703C17.5246 5.47221 17.2448 5.75203 16.8996 5.75203H3.125C2.77983 5.75203 2.5 5.47221 2.5 5.12703C2.5 4.78186 2.77983 4.50203 3.125 4.50203H6.36071L6.67506 2.93951C6.67767 2.92654 6.68069 2.91365 6.68412 2.90087C6.88004 2.17039 7.54282 1.6647 8.29812 1.66675ZM12.1281 3.21005L12.3906 4.50203H7.63576L7.89571 3.20988C7.94929 3.03582 8.11062 2.91612 8.29504 2.91675H11.7315C11.9142 2.91675 12.0751 3.0366 12.1281 3.21005ZM4.87222 7.70198C4.84707 7.3577 4.54761 7.09901 4.20335 7.12417C3.85908 7.14932 3.6004 7.44878 3.62555 7.79306L4.13551 14.7727C4.26476 16.544 5.73972 17.9158 7.51538 17.9158H12.5096C14.286 17.9158 15.7602 16.544 15.8895 14.7736L16.3995 7.79306C16.4245 7.44878 16.1659 7.14932 15.8216 7.12417C15.4774 7.09902 15.1779 7.35771 15.1527 7.70198L14.6428 14.6826C14.5612 15.8 13.6307 16.6658 12.5096 16.6658H7.51538C6.39509 16.6658 5.46377 15.7999 5.38219 14.6816L4.87222 7.70198ZM9.05521 9.60948C9.05521 9.26432 8.77538 8.98448 8.43021 8.98448C8.08496 8.98448 7.80518 9.26432 7.80518 9.60948V13.3665C7.80518 13.7116 8.08496 13.9915 8.43021 13.9915C8.77538 13.9915 9.05521 13.7116 9.05521 13.3665V9.60948ZM11.8722 9.60948C11.8722 9.26432 11.5924 8.98448 11.2472 8.98448C10.902 8.98448 10.6222 9.26432 10.6222 9.60948V13.3665C10.6222 13.7116 10.902 13.9915 11.2472 13.9915C11.5924 13.9915 11.8722 13.7116 11.8722 13.3665V9.60948Z"
        fill={color}
      />
    </g>
  </svg>
);

export const QRIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33325 5.74324C3.33325 4.29744 4.50549 3.125 5.9523 3.125H7.02663C7.3718 3.125 7.65163 2.84517 7.65163 2.5C7.65163 2.15483 7.3718 1.875 7.02663 1.875H5.9523C3.81534 1.875 2.08325 3.60688 2.08325 5.74324V7.05756C2.08325 7.40274 2.36308 7.68256 2.70825 7.68256C3.05343 7.68256 3.33325 7.40274 3.33325 7.05756V5.74324ZM13.4163 1.875C13.0711 1.875 12.7913 2.15483 12.7913 2.5C12.7913 2.84517 13.0711 3.125 13.4163 3.125H14.4638C15.9107 3.125 17.0828 4.29744 17.0828 5.74324V7.05756C17.0828 7.40274 17.3627 7.68256 17.7078 7.68256C18.0531 7.68256 18.3328 7.40274 18.3328 7.05756V5.74324C18.3328 3.60688 16.6008 1.875 14.4638 1.875H13.4163ZM2.70825 12.3177C3.05343 12.3177 3.33325 12.5975 3.33325 12.9427V14.257C3.33325 15.7029 4.50549 16.8753 5.9523 16.8753H6.99987C7.34504 16.8753 7.62487 17.1551 7.62487 17.5003C7.62487 17.8455 7.34504 18.1253 6.99987 18.1253H5.9523C3.81534 18.1253 2.08325 16.3935 2.08325 14.257V12.9427C2.08325 12.5975 2.36308 12.3177 2.70825 12.3177ZM18.3336 12.9427C18.3336 12.5975 18.0538 12.3177 17.7086 12.3177C17.3634 12.3177 17.0836 12.5975 17.0836 12.9427V14.257C17.0836 15.7029 15.9114 16.8753 14.4645 16.8753H13.3903C13.045 16.8753 12.7653 17.1551 12.7653 17.5003C12.7653 17.8455 13.045 18.1253 13.3903 18.1253H14.4645C16.6015 18.1253 18.3336 16.3935 18.3336 14.257V12.9427ZM6.57586 6.22396C6.49703 6.22396 6.43221 6.28787 6.43221 6.36842V7.79544C6.43221 7.87512 6.49617 7.93909 6.57586 7.93909H8.00289C8.08257 7.93909 8.14653 7.87512 8.14653 7.79544V6.36842C8.14653 6.28787 8.08171 6.22396 8.00289 6.22396H6.57586ZM5.18221 6.36842C5.18221 5.59923 5.80496 4.97396 6.57586 4.97396H8.00289C8.77375 4.97396 9.3965 5.59923 9.3965 6.36842V7.79544C9.3965 8.5655 8.77292 9.18908 8.00289 9.18908H6.57586C5.80582 9.18908 5.18221 8.5655 5.18221 7.79544V6.36842ZM6.43221 12.1465C6.43221 12.0659 6.49703 12.002 6.57586 12.002H8.06207C8.1409 12.002 8.20572 12.0659 8.20572 12.1465V13.6327C8.20572 13.712 8.14133 13.7763 8.06207 13.7763H6.57586C6.4966 13.7763 6.43221 13.712 6.43221 13.6327V12.1465ZM6.57586 10.752C5.80496 10.752 5.18221 11.3773 5.18221 12.1465V13.6327C5.18221 14.4015 5.80539 15.0263 6.57586 15.0263H8.06207C8.8325 15.0263 9.45575 14.4015 9.45575 13.6327V12.1465C9.45575 11.3773 8.833 10.752 8.06207 10.752H6.57586ZM12.3538 6.22396C12.2742 6.22396 12.2102 6.28792 12.2102 6.36761V7.85382C12.2102 7.93351 12.2742 7.99747 12.3538 7.99747H13.8401C13.9197 7.99747 13.9837 7.93351 13.9837 7.85382V6.36761C13.9837 6.28792 13.9197 6.22396 13.8401 6.22396H12.3538ZM10.9602 6.36761C10.9602 5.59757 11.5838 4.97396 12.3538 4.97396H13.8401C14.6101 4.97396 15.2337 5.59757 15.2337 6.36761V7.85382C15.2337 8.62383 14.6101 9.2475 13.8401 9.2475H12.3538C11.5838 9.2475 10.9602 8.62383 10.9602 7.85382V6.36761ZM12.0247 13.776C11.6795 13.776 11.3997 14.0559 11.3997 14.401C11.3997 14.7463 11.6795 15.026 12.0247 15.026H12.0749C12.4201 15.026 12.6999 14.7463 12.6999 14.401C12.6999 14.0559 12.4201 13.776 12.0749 13.776H12.0247ZM13.9842 14.401C13.9842 14.0559 14.2641 13.776 14.6092 13.776H14.6596C15.0047 13.776 15.2846 14.0559 15.2846 14.401C15.2846 14.7463 15.0047 15.026 14.6596 15.026H14.6092C14.2641 15.026 13.9842 14.7463 13.9842 14.401ZM14.6092 11.1914C14.2641 11.1914 13.9842 11.4712 13.9842 11.8164C13.9842 12.1616 14.2641 12.4414 14.6092 12.4414H14.6596C15.0047 12.4414 15.2846 12.1616 15.2846 11.8164C15.2846 11.4712 15.0047 11.1914 14.6596 11.1914H14.6092ZM12.692 13.1087C12.692 12.7636 12.9719 12.4837 13.317 12.4837H13.3673C13.7124 12.4837 13.9923 12.7636 13.9923 13.1087C13.9923 13.4539 13.7124 13.7337 13.3673 13.7337H13.317C12.9719 13.7337 12.692 13.4539 12.692 13.1087ZM12.0247 11.1914C11.6795 11.1914 11.3997 11.4712 11.3997 11.8164C11.3997 12.1616 11.6795 12.4414 12.0247 12.4414H12.0749C12.4201 12.4414 12.6999 12.1616 12.6999 11.8164C12.6999 11.4712 12.4201 11.1914 12.0749 11.1914H12.0247Z"
      fill="#6C757D"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1613 0.833496C12.5063 0.833496 12.7863 1.1135 12.7863 1.4585L12.7867 2.165C14.0034 2.24843 15.014 2.6652 15.7292 3.38191C16.51 4.16608 16.9209 5.29358 16.9167 6.64608V14.2486C16.9167 17.0252 15.1534 18.7502 12.3159 18.7502H5.26752C2.43002 18.7502 0.666687 17.0011 0.666687 14.1852V6.64441C0.666687 4.02541 2.23923 2.34428 4.80393 2.16529L4.80444 1.4585C4.80444 1.1135 5.08444 0.833496 5.42944 0.833496C5.77444 0.833496 6.05444 1.1135 6.05444 1.4585L6.05419 2.14933H11.5359L11.5363 1.4585C11.5363 1.1135 11.8163 0.833496 12.1613 0.833496ZM15.6667 8.2535H1.91669V14.1852C1.91669 16.3236 3.10669 17.5002 5.26752 17.5002H12.3159C14.4767 17.5002 15.6667 16.3452 15.6667 14.2486L15.6667 8.2535ZM12.501 13.4971C12.846 13.4971 13.126 13.7771 13.126 14.1221C13.126 14.4671 12.846 14.7471 12.501 14.7471C12.156 14.7471 11.8727 14.4671 11.8727 14.1221C11.8727 13.7771 12.1485 13.4971 12.4935 13.4971H12.501ZM8.8031 13.4971C9.1481 13.4971 9.4281 13.7771 9.4281 14.1221C9.4281 14.4671 9.1481 14.7471 8.8031 14.7471C8.4581 14.7471 8.17477 14.4671 8.17477 14.1221C8.17477 13.7771 8.4506 13.4971 8.7956 13.4971H8.8031ZM5.09744 13.4971C5.44244 13.4971 5.72244 13.7771 5.72244 14.1221C5.72244 14.4671 5.44244 14.7471 5.09744 14.7471C4.75244 14.7471 4.46827 14.4671 4.46827 14.1221C4.46827 13.7771 4.74494 13.4971 5.08994 13.4971H5.09744ZM12.501 10.2582C12.846 10.2582 13.126 10.5382 13.126 10.8832C13.126 11.2282 12.846 11.5082 12.501 11.5082C12.156 11.5082 11.8727 11.2282 11.8727 10.8832C11.8727 10.5382 12.1485 10.2582 12.4935 10.2582H12.501ZM8.8031 10.2582C9.1481 10.2582 9.4281 10.5382 9.4281 10.8832C9.4281 11.2282 9.1481 11.5082 8.8031 11.5082C8.4581 11.5082 8.17477 11.2282 8.17477 10.8832C8.17477 10.5382 8.4506 10.2582 8.7956 10.2582H8.8031ZM5.09744 10.2582C5.44244 10.2582 5.72244 10.5382 5.72244 10.8832C5.72244 11.2282 5.44244 11.5082 5.09744 11.5082C4.75244 11.5082 4.46827 11.2282 4.46827 10.8832C4.46827 10.5382 4.74494 10.2582 5.08994 10.2582H5.09744ZM11.5359 3.39933H6.05419L6.05444 4.201C6.05444 4.546 5.77444 4.826 5.42944 4.826C5.08444 4.826 4.80444 4.546 4.80444 4.201L4.80399 3.41825C2.93713 3.57507 1.91669 4.70671 1.91669 6.64441V7.0035H15.6667L15.6667 6.64441C15.67 5.61525 15.3934 4.81525 14.8442 4.26525C14.3621 3.78175 13.6574 3.493 12.787 3.41865L12.7863 4.201C12.7863 4.546 12.5063 4.826 12.1613 4.826C11.8163 4.826 11.5363 4.546 11.5363 4.201L11.5359 3.39933Z"
      fill="#6C757D"
    />
  </svg>
);

export const CreateDraftIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.27381 0.875029H8.98248C9.61648 0.875029 10.2247 1.13278 10.665 1.59176C10.6649 1.59168 10.6651 1.59185 10.665 1.59176L13.8247 4.88284C14.242 5.31785 14.4748 5.89711 14.4748 6.49866V7.58191C14.4748 7.92708 14.195 8.20691 13.8498 8.20691C13.5046 8.20691 13.2248 7.92708 13.2248 7.58191V6.49866C13.2248 6.21976 13.117 5.95081 12.923 5.74855C12.923 5.74849 12.9231 5.74861 12.923 5.74855L9.76332 2.45747C9.55982 2.24528 9.27757 2.12503 8.98248 2.12503H4.26985C2.91244 2.1192 1.79985 3.19897 1.76375 4.55491V13.303L1.76361 13.3165C1.7338 14.6967 2.82579 15.8402 4.20445 15.8742L7.53231 15.875L7.53281 16.5L7.53257 17.125L4.19712 17.1242L4.18333 17.124C2.11334 17.0783 0.472881 15.3651 0.513748 13.2965V4.54705L0.513931 4.53214C0.562573 2.49294 2.23366 0.867021 4.27381 0.875029ZM7.53281 16.5L7.53257 17.125C7.87782 17.1251 8.15773 16.8453 8.15781 16.5002C8.1579 16.155 7.87748 15.8751 7.53231 15.875L7.53281 16.5Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38507 0.927246C9.73024 0.927246 10.0101 1.20707 10.0101 1.55225V3.96278C10.0095 4.79386 10.6824 5.46901 11.5142 5.47102H13.7959C14.1411 5.47102 14.4209 5.75085 14.4209 6.09602C14.4209 6.4412 14.1411 6.72102 13.7959 6.72102H11.5122C9.9914 6.71788 8.75924 5.4843 8.76007 3.96278C8.76007 3.96271 8.76007 3.96285 8.76007 3.96278V1.55225C8.76007 1.20707 9.0399 0.927246 9.38507 0.927246Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09698 7.31689C4.09698 6.97172 4.3768 6.69189 4.72198 6.69189H6.77898C7.12414 6.69189 7.40398 6.97172 7.40398 7.31689C7.40398 7.66209 7.12414 7.94192 6.77898 7.94192H4.72198C4.3768 7.94192 4.09698 7.66209 4.09698 7.31689ZM4.09778 10.7573C4.09778 10.4121 4.37759 10.1323 4.72278 10.1323H8.66331C9.00848 10.1323 9.28831 10.4121 9.28831 10.7573C9.28831 11.1025 9.00848 11.3823 8.66331 11.3823H4.72278C4.37759 11.3823 4.09778 11.1025 4.09778 10.7573Z"
      fill={color}
    />
    <path
      d="M11.3914 17.0833C11.0987 17.0831 10.815 16.9812 10.5889 16.7952C10.3627 16.6092 10.2082 16.3506 10.1515 16.0633L10.0398 15.5042C9.93458 14.9747 10.0252 14.4251 10.2948 13.9575L12.3189 10.4525C12.4177 10.2812 12.5492 10.1312 12.706 10.0107C12.8628 9.89041 13.0417 9.80208 13.2327 9.75091C13.4237 9.69983 13.6227 9.68674 13.8187 9.71266C14.0147 9.73849 14.2037 9.80266 14.3747 9.90166L15.0239 10.2767C15.3698 10.4762 15.6226 10.8047 15.7266 11.1902C15.8307 11.5757 15.7776 11.9868 15.579 12.3333L13.5522 15.8333C13.282 16.3007 12.8511 16.6541 12.3397 16.8275L11.7972 17.0117C11.6669 17.0578 11.5297 17.082 11.3914 17.0833ZM13.6231 10.95C13.6001 10.9499 13.5772 10.9527 13.5547 10.9583C13.5227 10.9669 13.4928 10.9818 13.4667 11.0022C13.4405 11.0225 13.4186 11.0477 13.4023 11.0767L11.3772 14.5833C11.2597 14.7887 11.2198 15.0293 11.2648 15.2617L11.3765 15.8217L11.9389 15.6492C12.1627 15.5727 12.3512 15.4179 12.4697 15.2133L14.4922 11.7133C14.5259 11.6546 14.535 11.5849 14.5175 11.5195C14.5 11.4541 14.4574 11.3982 14.3989 11.3642L13.7497 10.9892C13.7118 10.9649 13.6681 10.9514 13.6231 10.95Z"
      fill={color}
    />
  </svg>
);

export const UploadImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22999 4.72269C6.98541 4.47912 6.98459 4.08339 7.22818 3.83881L9.65816 1.39881C9.77549 1.28104 9.93483 1.21484 10.101 1.21484C10.2672 1.21484 10.4266 1.28104 10.5439 1.39881L12.9739 3.83881C13.2174 4.08339 13.2167 4.47912 12.9721 4.72269C12.7275 4.96627 12.3317 4.96546 12.0882 4.72088L10.726 3.35311V11.875C10.726 12.2202 10.4462 12.5 10.101 12.5C9.75582 12.5 9.47598 12.2202 9.47598 11.875V3.35314L8.11387 4.72088C7.87029 4.96546 7.47457 4.96627 7.22999 4.72269ZM6.41603 6.98923C4.97245 7.12229 4.18836 7.44588 3.70873 8.09313C3.19578 8.78535 2.91699 9.98968 2.91699 12.2002C2.91699 15.1595 3.41571 16.2994 4.30454 16.8454C4.78449 17.1403 5.4532 17.3135 6.41396 17.4029C7.37244 17.4921 8.54433 17.4927 10.0003 17.4927C11.4563 17.4927 12.6282 17.4921 13.5867 17.4029C14.5474 17.3135 15.2162 17.1403 15.6961 16.8454C16.5849 16.2994 17.0837 15.1595 17.0837 12.2002C17.0837 9.98968 16.8049 8.78535 16.2919 8.09313C15.8123 7.44588 15.0282 7.12229 13.5847 6.98923C13.2409 6.95754 12.9879 6.65322 13.0197 6.30949C13.0513 5.96578 13.3557 5.71282 13.6993 5.7445C15.2392 5.88643 16.4883 6.25869 17.2962 7.34893C18.0707 8.39418 18.3337 9.96902 18.3337 12.2002C18.3337 15.1583 17.8699 16.9772 16.3504 17.9106C15.6262 18.3554 14.7292 18.552 13.7025 18.6475C12.6798 18.7427 11.4512 18.7427 10.0267 18.7427H10.0267H9.97399H9.97391C8.54944 18.7427 7.32085 18.7427 6.29815 18.6475C5.27141 18.552 4.37449 18.3554 3.65028 17.9106C2.13078 16.9772 1.66699 15.1583 1.66699 12.2002C1.66699 9.96902 1.92988 8.39418 2.70442 7.34893C3.51229 6.25869 4.76153 5.88643 6.30129 5.7445C6.64501 5.71282 6.94933 5.96578 6.98102 6.30949C7.0127 6.65322 6.75975 6.95754 6.41603 6.98923Z"
      fill="#004F96"
    />
  </svg>
);

// Line/Close
export const CloseIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L10.9393 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9393L6.53033 5.46967Z"
      fill={color}
    />
  </svg>
);

export const CloseFilledIcon = ({ color = "#ADB5BD" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9482 19.8983L19.5335 21.3129L16.3322 18.1143L13.1322 21.3089L11.7188 19.8943L14.9175 16.7009L11.7188 13.5036L13.1335 12.0889L16.3335 15.2876L19.5348 12.0916L20.9482 13.5076L17.7482 16.7009L20.9482 19.8983ZM16.3335 3.71289C9.1655 3.71289 3.3335 9.54489 3.3335 16.7129C3.3335 23.8809 9.1655 29.7129 16.3335 29.7129C23.5015 29.7129 29.3335 23.8809 29.3335 16.7129C29.3335 9.54489 23.5015 3.71289 16.3335 3.71289Z"
      fill={color}
    />
  </svg>
);

// Check Icon Custom not from design
export const CheckIcon = ({ color = DEFAULT_COLOR }) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none">
    <g>
      <title>Layer 1</title>
      <path
        id="svg_2"
        fill={color}
        d="m16.2431,9.16108c0.2928,0.29289 0.2928,0.76776 0,1.06062l-4.6178,4.6178c-0.2928,0.2928 -0.7676,0.2929 -1.0605,0.0001l-2.30986,-2.3089c-0.29296,-0.2928 -0.29306,-0.7677 -0.00023,-1.0606c0.29284,-0.293 0.76771,-0.2931 1.06066,-0.0003l1.77953,1.7788l4.0875,-4.08752c0.2929,-0.2929 0.7678,-0.2929 1.0607,0z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

// Drag Line/Drag
export const DragIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.76466 4.71875C8.06966 4.71875 7.50366 5.28375 7.50366 5.97975C7.50366 6.67475 8.06966 7.23975 8.76466 7.23975C9.45966 7.23975 10.0257 6.67475 10.0257 5.97975C10.0257 5.28375 9.45966 4.71875 8.76466 4.71875ZM7.50366 12.0012C7.50366 11.3052 8.06966 10.7402 8.76466 10.7402C9.45966 10.7402 10.0257 11.3052 10.0257 12.0012C10.0257 12.6962 9.45966 13.2612 8.76466 13.2612C8.06966 13.2612 7.50366 12.6962 7.50366 12.0012ZM7.50366 18.0227C7.50366 17.3267 8.06966 16.7617 8.76466 16.7617C9.45966 16.7617 10.0257 17.3267 10.0257 18.0227C10.0257 18.7177 9.45966 19.2827 8.76466 19.2827C8.06966 19.2827 7.50366 18.7177 7.50366 18.0227ZM13.9744 18.0227C13.9744 17.3267 14.5404 16.7617 15.2354 16.7617C15.9304 16.7617 16.4964 17.3267 16.4964 18.0227C16.4964 18.7177 15.9304 19.2827 15.2354 19.2827C14.5404 19.2827 13.9744 18.7177 13.9744 18.0227ZM15.2354 10.7402C14.5404 10.7402 13.9744 11.3052 13.9744 12.0012C13.9744 12.6962 14.5404 13.2612 15.2354 13.2612C15.9304 13.2612 16.4964 12.6962 16.4964 12.0012C16.4964 11.3052 15.9304 10.7402 15.2354 10.7402ZM16.4964 5.97875C16.4964 6.67475 15.9304 7.23975 15.2354 7.23975C14.5404 7.23975 13.9744 6.67475 13.9744 5.97875C13.9744 5.28375 14.5404 4.71875 15.2354 4.71875C15.9304 4.71875 16.4964 5.28375 16.4964 5.97875Z"
      fill="#6C757D"
    />
  </svg>
);

// New section Line/Plus
export const PlusIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 5C12.4141 5 12.75 5.33582 12.75 5.75V11H18C18.4141 11 18.75 11.3358 18.75 11.75C18.75 11.9766 18.6494 12.1797 18.4907 12.3171C18.3594 12.431 18.1875 12.5 18 12.5H12.75V17.75C12.75 18.1642 12.4141 18.5 12 18.5C11.5859 18.5 11.25 18.1642 11.25 17.75V12.5H6C5.58594 12.5 5.25 12.1642 5.25 11.75C5.25 11.3358 5.58594 11 6 11H11.25V5.75C11.25 5.33582 11.5859 5 12 5Z"
      fill={color}
    />
  </svg>
);

export const EllipseDelete = () => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="38" cy="38" r="38" fill="#EC2D30" fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.269 40.139C39.269 40.829 38.709 41.389 38.019 41.389C37.329 41.389 36.769 40.829 36.769 40.139V35.119C36.769 34.4291 37.329 33.8691 38.019 33.8691C38.709 33.8691 39.269 34.4291 39.269 35.119V40.139ZM38.0157 46.424C37.3257 46.424 36.7657 45.904 36.7657 45.214V45.1323C36.7657 44.4423 37.3257 43.8823 38.0157 43.8823C38.7057 43.8823 39.2657 44.4423 39.2657 45.1323C39.2657 45.8223 38.7057 46.424 38.0157 46.424ZM53.284 46.1223L41.684 25.7624C40.9357 24.4524 39.589 23.6674 38.0807 23.6641H38.0724C36.5707 23.6641 35.2257 24.4424 34.4757 25.7441L22.729 46.1023C21.9773 47.4023 21.9773 48.9573 22.7273 50.2573C23.4773 51.559 24.824 52.334 26.3257 52.334H49.6724C51.1707 52.334 52.5124 51.5623 53.2657 50.2657C54.019 48.9723 54.0257 47.4223 53.284 46.1223Z"
      fill="#EC2D30"
    />
  </svg>
);

export const EllipseInfo = () => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="38" cy="38" r="38" fill="#E88B00" fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.2598 44.1548C39.2598 44.8448 38.6998 45.4048 38.0098 45.4048C37.3198 45.4048 36.7598 44.8448 36.7598 44.1548V36.9898C36.7598 36.2998 37.3198 35.7398 38.0098 35.7398C38.6998 35.7398 39.2598 36.2998 39.2598 36.9898V44.1548ZM36.7498 31.8182C36.7498 31.1282 37.3098 30.5682 37.9998 30.5682C38.6898 30.5682 39.2498 31.1282 39.2498 31.8182C39.2498 32.5082 38.6898 33.1215 37.9998 33.1215C37.3098 33.1215 36.7498 32.6132 36.7498 31.9232V31.8182ZM37.9998 22.1665C29.2698 22.1665 22.1665 29.2682 22.1665 37.9998C22.1665 46.7298 29.2698 53.8332 37.9998 53.8332C46.7298 53.8332 53.8332 46.7298 53.8332 37.9998C53.8332 29.2682 46.7298 22.1665 37.9998 22.1665Z"
      fill="#FC9E11"
    />
  </svg>
);

export const EllipseSave = () => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="38" cy="38" r="38" fill="#05C73B" fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.6553 35.0367L36.9587 42.7333C36.7137 42.9783 36.3953 43.1 36.0753 43.1C35.7537 43.1 35.4353 42.9783 35.1903 42.7333L31.342 38.885C30.8537 38.3967 30.8537 37.605 31.342 37.1167C31.8303 36.6283 32.6203 36.6283 33.1087 37.1167L36.0753 40.0817L42.887 33.2683C43.3753 32.78 44.167 32.78 44.6553 33.2683C45.1437 33.7567 45.1437 34.5483 44.6553 35.0367ZM38.0003 22.1667C29.2703 22.1667 22.167 29.27 22.167 38C22.167 46.7317 29.2703 53.8333 38.0003 53.8333C46.7303 53.8333 53.8337 46.7317 53.8337 38C53.8337 29.27 46.7303 22.1667 38.0003 22.1667Z"
      fill="#049F2F"
    />
  </svg>
);

export const WarningFilled = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6345 11.0695C10.6345 11.4145 10.3545 11.6945 10.0095 11.6945C9.66452 11.6945 9.38452 11.4145 9.38452 11.0695V8.5595C9.38452 8.21453 9.66452 7.93453 10.0095 7.93453C10.3545 7.93453 10.6345 8.21453 10.6345 8.5595V11.0695ZM10.0078 14.212C9.66285 14.212 9.38285 13.952 9.38285 13.607V13.5662C9.38285 13.2212 9.66285 12.9412 10.0078 12.9412C10.3528 12.9412 10.6328 13.2212 10.6328 13.5662C10.6328 13.9112 10.3528 14.212 10.0078 14.212ZM17.642 14.0612L11.842 3.8812C11.4678 3.2262 10.7945 2.8337 10.0403 2.83203H10.0362C9.28535 2.83203 8.61285 3.2212 8.23783 3.87203L2.3645 14.0512C1.98867 14.7012 1.98867 15.4787 2.36367 16.1287C2.73867 16.7795 3.412 17.167 4.16283 17.167H15.8362C16.5853 17.167 17.2562 16.7812 17.6328 16.1328C18.0095 15.4862 18.0128 14.7112 17.642 14.0612Z"
      fill="#EC2D30"
    />
  </svg>
);

export const CircleFilled = ({ color = "#0065C0" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2619_5272)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48631 2 2 6.48631 2 12C2 17.5137 6.48631 22 12 22C17.5137 22 22 17.5137 22 12C22 6.48631 17.5137 2 12 2Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2619_5272">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CircleUnfilled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2619_3049)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 3.75098C7.69359 3.75098 4 7.44457 4 12.001C4 16.5563 7.69354 20.25 12.25 20.25C16.8065 20.25 20.5 16.5563 20.5 12.001C20.5 7.44457 16.8064 3.75098 12.25 3.75098ZM2.5 12.001C2.5 6.61614 6.86516 2.25098 12.25 2.25098C17.6348 2.25098 22 6.61614 22 12.001C22 17.3849 17.6348 21.75 12.25 21.75C6.86522 21.75 2.5 17.3849 2.5 12.001Z"
        fill="#ADB5BD"
      />
    </g>
    <defs>
      <clipPath id="clip0_2619_3049">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
  >
    <mask
      id="mask0_945_13311"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="140"
      height="140"
    >
      <circle cx="70" cy="70" r="70" fill="#CED4DA" />
    </mask>
    <g mask="url(#mask0_945_13311)">
      <circle cx="69.5" cy="144.5" r="64.5" fill="#ADB5BD" />
      <circle cx="69.5" cy="49.5" r="22.5" fill="#ADB5BD" />
    </g>
  </svg>
);

export const LanguageIcon = ({ color = DEFAULT_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.47 6.92916C20.4564 8.37311 21.0332 10.1191 21.0332 12C21.0332 16.9709 17.0041 21 12.0332 21C7.06228 21 3.0332 16.9709 3.0332 12C3.0332 7.02908 7.06228 3 12.0332 3C14.0698 3 15.9483 3.67629 17.4564 4.81657"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9791 3.20898C14.7186 4.3892 15.2897 6.23396 15.5894 8.43385C15.749 9.53915 15.8336 10.7378 15.8336 11.993C15.8336 13.2471 15.749 14.4556 15.5894 15.5609C15.2897 17.7608 14.7186 19.6055 13.9791 20.7857"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0938 20.7857C9.35437 19.6055 8.77351 17.7608 8.47383 15.5609C8.31427 14.4556 8.23059 13.2471 8.23059 11.993C8.23059 10.7378 8.31427 9.53915 8.47383 8.43385C8.77351 6.23396 9.35437 4.3892 10.0938 3.20898"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.815 10.0362C19.626 9.30643 17.791 8.7353 15.5901 8.43562C14.4848 8.27605 13.2861 8.19141 12.032 8.19141C10.7768 8.19141 9.57812 8.27605 8.47283 8.43562C7.77985 8.53002 7.12211 8.65223 6.50928 8.79819"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.24792 13.9424C4.42717 14.6818 6.27192 15.2627 8.47279 15.5624C9.57809 15.722 10.7768 15.8056 12.031 15.8056C13.2861 15.8056 14.4848 15.722 15.5901 15.5624C16.3361 15.4608 17.0403 15.3279 17.6916 15.1675"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserAvatarAddButton = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="23"
      cy="23"
      r="21.5"
      fill="#0065C0"
      stroke="white"
      strokeWidth="3"
    />
    <g clipPath="url(#clip0_945_13296)">
      <path
        d="M23 16C23.4141 16 23.75 16.3358 23.75 16.75V22H29C29.4141 22 29.75 22.3358 29.75 22.75C29.75 22.9766 29.6494 23.1797 29.4907 23.3171C29.3594 23.431 29.1875 23.5 29 23.5H23.75V28.75C23.75 29.1642 23.4141 29.5 23 29.5C22.5859 29.5 22.25 29.1642 22.25 28.75V23.5H17C16.5859 23.5 16.25 23.1642 16.25 22.75C16.25 22.3358 16.5859 22 17 22H22.25V16.75C22.25 16.3358 22.5859 16 23 16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_945_13296">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ActiveCarePlanHeaderImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="817"
    height="217"
    viewBox="0 0 817 217"
    fill="none"
  >
    <path
      d="M976.143 73.8248C958.847 101.906 925.952 100.852 897.526 108.216C892.291 109.571 872.168 115.432 875.589 123.8C878.487 130.881 890.587 119.443 892.846 116.177C904.57 99.2215 895.586 72.5964 872.566 75.3427C859.294 76.9281 848.808 86.755 839.376 95.4015C825.023 108.559 810.846 122.991 792.609 130.653C785.06 133.824 689.822 125.745 667.486 138.816C654.161 146.616 655.402 189.621 632.312 175.378C605.547 158.869 612.906 116.329 608.781 89.7487C608.299 86.6454 603.956 64.9254 597.227 68.8748C594.82 70.2887 596.017 79.649 596.006 82.0468C595.952 94.2911 597.698 106.482 597.278 118.732C596.759 133.911 594.128 148.924 592.971 164.053C592.228 173.776 589.88 188.589 596.577 196.702C601.35 202.484 609.196 204.777 616.078 206.88C632.354 211.852 652.679 215.195 669.663 213.089C679.185 211.909 687.908 207.439 690.969 197.75C694.945 185.157 690.302 171.538 687.746 159.142C683.178 137.009 675.811 115.677 666.101 95.2918C660.247 82.9997 653.872 70.7553 644.364 60.8636C633.811 49.8842 614.629 24.4565 597.216 38.4325C591.696 42.8625 590.449 50.3929 590.247 57.0745C589.863 69.8642 591.256 82.6483 590.749 95.4464C590.536 100.793 592.091 108.528 587.806 112.669C580.111 120.104 583.637 102.252 583.715 100.374C583.754 99.3874 583.807 97.2173 582.589 96.7788C581.518 96.3937 580.389 98.6115 579.957 99.258C578.842 100.928 575.661 107.978 573.17 107.48C570.466 106.94 571.864 102.831 572.47 101.279C574.978 94.8646 579.276 91.9525 579.663 84.4698C580.221 73.7067 578.724 62.9578 578.573 52.1947C578.475 45.2883 579.565 38.4859 580.293 31.6385C581.014 24.895 582.661 16.2121 579.01 10.0421C577.402 7.32396 574.823 4.91781 571.979 3.53202C571.842 3.46175 569.18 2.46106 569.115 2.69437C563.567 2.46949 557.772 4.32751 556.018 7.79619C552.753 14.2529 565.831 14.8516 569.222 15.0793C570.231 15.1468 573.375 15.1158 573.453 16.6562C573.551 18.6126 569.404 19.023 568.118 19.3041C564.155 20.1671 553.515 19.678 552.248 24.895C551.699 27.1522 554.143 28.122 555.877 28.628C558.977 29.5303 579.716 31.3349 569.589 39.5456C568.311 40.5828 566.851 41.3867 565.394 42.1373C563.222 43.2532 560.924 44.1386 558.8 45.3473C557.365 46.1653 554.305 47.7254 554.7 49.8251C555.507 54.1315 566.596 53.7857 569.847 55.2137C571.223 55.818 574.12 56.6978 573.801 58.6852C572.806 64.8692 554.465 64.3576 555.905 71.4158C557.466 79.0728 574.039 71.8684 576.026 78.0384C576.749 80.2871 572.59 81.493 571.181 81.9709C568.045 83.0334 555.272 83.1824 554.594 87.469C554.291 89.3917 556.903 91.483 558.217 92.391C561.672 94.7802 571.287 101.875 567.142 107.264C563.32 112.233 559.565 101.271 562.07 100.776C562.564 100.68 563.572 104.517 563.69 104.905C564.727 108.332 564.943 114.715 559.843 114.954C555.012 115.182 552.509 107.21 551.559 103.604C551.285 102.558 550.251 99.5616 551.324 98.634C552.478 97.6333 554.804 102.904 555.073 103.539C557.057 108.197 556.925 113.349 554.835 117.92C552.873 122.209 543.592 118.485 540.171 120.781C528.895 128.345 544.399 160.112 531.75 166.819C521.379 172.314 523.402 154.029 523.839 149.172C525.588 129.709 534.474 98.1393 525.846 80.0285C517.548 62.6092 493.337 79.2696 483.644 86.0776C480.713 88.1352 477.498 91.5955 474.035 92.7817C473.242 93.0543 470.793 94.0213 470.184 92.9616C467.522 88.3432 476.134 76.1045 478.737 72.5402C485.171 63.7336 492.95 56.5657 500.253 48.4984C507.875 40.074 517.119 29.4487 529.766 33.3587C533.972 34.6574 535.939 39.2195 537.517 42.958C541.471 52.324 542.393 62.7694 543.909 72.7426C545.999 86.5049 550.262 100.054 550.393 114.044C550.545 130.085 546.226 145.652 543.108 161.27C540.877 172.44 539.557 188.094 531.635 197.016C517.271 213.19 489.596 212.774 469.893 211.248C461.988 210.632 452.516 210.073 446.147 204.749C440.862 200.33 439.539 193.185 438.827 186.695C437.138 171.288 439.587 155.415 443.975 140.64C446.926 130.707 449.756 120.832 455.03 111.848C456.798 108.835 458.765 105.959 460.954 103.238C461.223 102.907 464.263 99.4689 464.28 100.127C464.387 104.188 459.485 109.307 457.389 112.382C453.94 117.433 449.686 124.272 443.891 126.889C439.458 128.888 433.783 129.037 429.028 129.841C421.095 131.182 412.111 133.248 404.077 131.615C373.776 125.453 352.268 97.698 319.614 98.7155C305.922 99.1428 291.633 101.566 279.6 108.408C264.317 117.096 252.693 130.861 237.547 139.755C214.585 153.233 190.856 150.934 160.454 150.616C90.709 149.888 58.5867 83.075 -6.61328 87.469C-71.8133 91.8631 -152.78 107.623 -185.113 114.954"
      stroke="#196E74"
      strokeWidth="4.66"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccountSettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1408 4.75C9.44367 4.75 8.06811 6.18287 8.06811 7.95073C8.06811 9.71783 9.44377 11.1515 11.1408 11.1515C12.8379 11.1515 14.2136 9.71783 14.2136 7.95073C14.2136 6.18287 12.838 4.75 11.1408 4.75ZM6.62811 7.95073C6.62811 5.35445 8.64837 3.25 11.1408 3.25C13.6332 3.25 15.6536 5.35445 15.6536 7.95073C15.6536 10.546 13.6333 12.6515 11.1408 12.6515C8.64828 12.6515 6.62811 10.546 6.62811 7.95073ZM16.3206 13.7656C16.7183 13.7656 17.0406 14.1014 17.0406 14.5156V14.7905C17.3938 14.9018 17.7277 15.0969 18.0135 15.3759L18.2418 15.238C18.5858 15.0302 19.0263 15.1521 19.2258 15.5104C19.4254 15.8687 19.3083 16.3277 18.9643 16.5355L18.7328 16.6754C18.8177 17.0585 18.8176 17.4579 18.7326 17.841L18.9643 17.981C19.3083 18.1888 19.4254 18.6478 19.2258 19.0061C19.0263 19.3644 18.5858 19.4863 18.2418 19.2785L18.0129 19.1403C17.7273 19.4192 17.3935 19.6144 17.0406 19.7256V20.0008C17.0406 20.415 16.7183 20.7508 16.3206 20.7508C15.923 20.7508 15.6006 20.415 15.6006 20.0008V19.7253C15.2478 19.6139 14.9143 19.4187 14.6288 19.1397L14.3995 19.2783C14.0555 19.4861 13.6149 19.3642 13.4154 19.0059C13.2159 18.6476 13.333 18.1886 13.677 17.9808L13.9096 17.8402C13.8248 17.4576 13.8248 17.0587 13.9095 16.676L13.677 16.5355C13.333 16.3277 13.2159 15.8687 13.4154 15.5104C13.6149 15.1521 14.0555 15.0302 14.3995 15.238L14.6285 15.3764C14.9141 15.0974 15.2478 14.9023 15.6006 14.7909V14.5156C15.6006 14.1014 15.923 13.7656 16.3206 13.7656ZM15.5892 16.495C15.1849 16.9166 15.185 17.5995 15.5895 18.0209C15.9933 18.4415 16.6492 18.4415 17.0529 18.0209C17.4576 17.5994 17.4576 16.9163 17.053 16.4948L17.1289 16.4156L16.9773 16.4234C16.5709 16.0766 15.9686 16.1005 15.5892 16.495ZM15.5892 16.495L16.9773 16.4234C17.0034 16.4457 17.0287 16.4695 17.053 16.4948L15.5892 16.495ZM11.1423 14.0039C9.52467 14.0039 7.94261 14.1284 6.74287 14.5475C6.13932 14.7583 5.57907 15.0616 5.16328 15.5115C4.73044 15.9799 4.48499 16.5756 4.48499 17.2785C4.48499 17.9799 4.72847 18.5758 5.15902 19.0457C5.57295 19.4976 6.13142 19.8037 6.73456 20.0171C7.93325 20.4414 9.51604 20.5703 11.1423 20.5703C11.5399 20.5703 11.8623 20.2345 11.8623 19.8203C11.8623 19.4061 11.5399 19.0703 11.1423 19.0703C9.54873 19.0703 8.16286 18.9385 7.19785 18.5969C6.71913 18.4275 6.39699 18.2243 6.20077 18.0102C6.02118 17.8141 5.92499 17.5872 5.92499 17.2785C5.92499 16.9711 6.02107 16.7462 6.20072 16.5518C6.39741 16.339 6.72058 16.1374 7.20075 15.9696C8.16844 15.6316 9.55503 15.5039 11.1423 15.5039C11.5399 15.5039 11.8623 15.1681 11.8623 14.7539C11.8623 14.3397 11.5399 14.0039 11.1423 14.0039Z"
      fill="#6C757D"
    />
  </svg>
);

export const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.9806 22.2298C13.9806 22.2298 13.8906 22.2298 13.8406 22.2198C13.4306 22.1398 13.1606 21.7498 13.2406 21.3498C13.2806 21.1398 13.6506 19.3098 14.9306 18.6298C15.3006 18.4398 15.7506 18.5798 15.9406 18.9398C16.1306 19.2998 15.9906 19.7598 15.6306 19.9498C15.1306 20.2098 14.8006 21.1798 14.7206 21.6098C14.6506 21.9698 14.3406 22.2198 13.9806 22.2198V22.2298Z"
      fill="#6C757D"
    />
    <path
      d="M16.9701 20.4206L14.1701 19.7906C12.9701 19.5306 12.7601 18.5506 12.6101 17.8406C12.5801 17.6906 12.5501 17.5306 12.5001 17.3806C12.3901 16.9806 12.6201 16.5706 13.0201 16.4606C13.4201 16.3506 13.8301 16.5806 13.9401 16.9806C13.9901 17.1706 14.0301 17.3506 14.0701 17.5306C14.2201 18.2506 14.2801 18.2906 14.4901 18.3306L17.2801 18.9606C17.4001 18.9806 17.5301 18.9706 17.6001 18.9206C17.6601 18.8806 17.6901 18.8106 17.7101 18.7106L18.0201 16.0906C18.1301 15.5006 18.5101 15.0506 19.0101 14.8606L19.9301 14.5006C18.6201 12.7006 18.1101 11.2306 18.3901 9.96063C18.8401 7.92063 18.1501 6.21062 16.2201 4.58062C15.0801 3.62062 13.6001 3.19062 11.6001 3.23062C11.2001 3.26062 10.8401 2.91061 10.8301 2.50061C10.8301 2.09061 11.1501 1.74062 11.5601 1.73062C13.9601 1.69062 15.7501 2.22063 17.1801 3.43063C19.5501 5.43063 20.4201 7.6706 19.8401 10.2806C19.6601 11.0806 20.1001 12.1906 21.1201 13.5706C21.4101 13.9606 21.5001 14.4506 21.3701 14.9006C21.2401 15.3506 20.9001 15.7106 20.4501 15.8906L19.5201 16.2506L19.1701 18.9006C19.0901 19.4406 18.8301 19.8706 18.4301 20.1506C18.0483 20.4179 17.4261 20.5118 16.9701 20.4206Z"
      fill="#6C757D"
    />
    <path
      d="M5.73047 10.2695C5.32047 10.2695 4.98047 9.92953 4.98047 9.51953C4.98047 9.10953 5.32047 8.76953 5.73047 8.76953C6.14047 8.76953 6.48047 9.09953 6.48047 9.51953C6.48047 9.93953 6.14047 10.2795 5.73047 10.2795V10.2695Z"
      fill="#6C757D"
    />
    <path
      d="M5.73022 8.22046C5.32021 8.22046 4.99022 7.89047 4.98022 7.48047C4.97022 6.35047 5.8702 5.84046 6.4202 5.53046L6.54022 5.46048C7.20021 5.10048 7.2002 4.63047 7.2002 4.48047C7.2002 3.79047 6.6402 3.23047 5.9502 3.23047C5.2602 3.23047 4.7002 3.78047 4.7002 4.48047C4.7002 4.89047 4.3602 5.23047 3.9502 5.23047C3.5402 5.23047 3.2002 4.89047 3.2002 4.48047C3.2002 2.96047 4.4302 1.73047 5.9502 1.73047C7.4702 1.73047 8.7002 2.97047 8.7002 4.48047C8.7002 5.45047 8.19021 6.26048 7.28021 6.77048L7.16022 6.84045C6.66022 7.12045 6.4902 7.26048 6.4902 7.46048C6.4902 7.87048 6.16021 8.21046 5.75021 8.22046H5.73022Z"
      fill="#6C757D"
    />
    <path
      d="M5.28039 21.9996C5.18039 21.9996 5.08041 21.9796 4.98041 21.9396C4.60041 21.7696 4.43039 21.3296 4.59039 20.9496C5.60039 18.6396 5.32039 16.0396 3.74039 13.2096C3.54039 12.8496 3.67039 12.3896 4.03039 12.1896C4.39039 11.9896 4.85038 12.1196 5.05038 12.4796C6.84038 15.6896 7.1604 18.8296 5.9704 21.5496C5.8504 21.8296 5.57039 21.9996 5.28039 21.9996Z"
      fill="#6C757D"
    />
  </svg>
);

export const LogoutIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3083 2C13.7543 2 15.7443 3.99 15.7443 6.436V7.368C15.7443 7.782 15.4083 8.118 14.9943 8.118C14.5803 8.118 14.2443 7.782 14.2443 7.368V6.436C14.2443 4.816 12.9273 3.5 11.3083 3.5H6.43331C4.81631 3.5 3.50031 4.816 3.50031 6.436V17.565C3.50031 19.184 4.81631 20.5 6.43331 20.5H11.3193C12.9313 20.5 14.2443 19.188 14.2443 17.576V16.633C14.2443 16.219 14.5803 15.883 14.9943 15.883C15.4083 15.883 15.7443 16.219 15.7443 16.633V17.576C15.7443 20.016 13.7583 22 11.3193 22H6.43331C3.98931 22 2.00031 20.011 2.00031 17.565V6.436C2.00031 3.99 3.98931 2 6.43331 2H11.3083ZM19.3884 8.554L22.3164 11.469C22.3425 11.4949 22.3659 11.5219 22.3873 11.5504L22.3164 11.469C22.3518 11.5039 22.3833 11.5421 22.4107 11.5828C22.4227 11.6012 22.4343 11.6203 22.4451 11.6399C22.4538 11.6552 22.4618 11.6712 22.4693 11.6875C22.4756 11.7018 22.4817 11.7162 22.4873 11.7308C22.4948 11.7498 22.5014 11.7693 22.5072 11.7891C22.5116 11.8047 22.5156 11.8203 22.5191 11.836C22.5236 11.8551 22.5271 11.8743 22.5298 11.8937C22.5314 11.9063 22.5329 11.9195 22.5341 11.9328C22.5364 11.9556 22.5374 11.9777 22.5374 12L22.5323 12.062L22.5303 12.1017C22.53 12.1034 22.5298 12.1051 22.5295 12.1068L22.5374 12C22.5374 12.0555 22.5313 12.1105 22.5193 12.1639C22.5156 12.1797 22.5116 12.1953 22.5071 12.2107C22.5014 12.2307 22.4948 12.2502 22.4874 12.2695C22.4817 12.2838 22.4756 12.2982 22.4691 12.3123C22.4618 12.3288 22.4538 12.3448 22.4452 12.3605C22.4343 12.3797 22.4227 12.3988 22.4103 12.4172C22.4033 12.4282 22.3956 12.439 22.3876 12.4497C22.3638 12.481 22.3378 12.5104 22.3098 12.5377L19.3884 15.447C19.2424 15.593 19.0504 15.666 18.8594 15.666C18.6674 15.666 18.4744 15.593 18.3284 15.445C18.0364 15.151 18.0374 14.677 18.3304 14.385L19.9703 12.75H9.74611C9.33211 12.75 8.99611 12.414 8.99611 12C8.99611 11.586 9.33211 11.25 9.74611 11.25H19.9723L18.3304 9.616C18.0374 9.324 18.0354 8.85 18.3284 8.556C18.6204 8.262 19.0944 8.262 19.3884 8.554Z"
      fill={color}
    />
  </svg>
);

export const UploadImageFilledIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="23"
      cy="23"
      r="21.5"
      fill="#0065C0"
      stroke="white"
      stroke-width="3"
    />
    <g clip-path="url(#clip0_945_13293)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6756 16.6674C19.3821 16.3751 19.3811 15.9003 19.6734 15.6068L22.5894 12.6788C22.7302 12.5374 22.9214 12.458 23.1208 12.458C23.3203 12.458 23.5115 12.5374 23.6523 12.6788L26.5683 15.6068C26.8605 15.9003 26.8596 16.3751 26.5661 16.6674C26.2726 16.9597 25.7977 16.9587 25.5054 16.6652L23.8708 15.0239V25.2502C23.8708 25.6644 23.5351 26.0002 23.1208 26.0002C22.7066 26.0002 22.3708 25.6644 22.3708 25.2502V15.024L20.7363 16.6652C20.444 16.9587 19.9691 16.9597 19.6756 16.6674ZM18.6988 19.3873C16.9666 19.5469 16.0256 19.9352 15.4501 20.712C14.8345 21.5426 14.5 22.9878 14.5 25.6404C14.5 29.1916 15.0985 30.5595 16.1651 31.2147C16.741 31.5685 17.5435 31.7764 18.6964 31.8837C19.8465 31.9907 21.2528 31.9914 23 31.9914C24.7472 31.9914 26.1535 31.9907 27.3036 31.8837C28.4565 31.7764 29.259 31.5685 29.8349 31.2147C30.9015 30.5595 31.5 29.1916 31.5 25.6404C31.5 22.9878 31.1655 21.5426 30.5499 20.712C29.9744 19.9352 29.0334 19.5469 27.3012 19.3873C26.8887 19.3492 26.5851 18.9841 26.6232 18.5716C26.6612 18.1591 27.0264 17.8556 27.4388 17.8936C29.2866 18.0639 30.7856 18.5106 31.7551 19.8189C32.6845 21.0732 33 22.963 33 25.6404C33 29.1902 32.4435 31.3728 30.6201 32.4929C29.751 33.0267 28.6747 33.2626 27.4426 33.3772C26.2154 33.4914 24.741 33.4914 23.0317 33.4914H23.0316H22.9684H22.9683C21.259 33.4914 19.7846 33.4914 18.5574 33.3772C17.3253 33.2626 16.249 33.0267 15.3799 32.4929C13.5565 31.3728 13 29.1902 13 25.6404C13 22.963 13.3155 21.0732 14.2449 19.8189C15.2144 18.5106 16.7134 18.0639 18.5612 17.8936C18.9736 17.8556 19.3388 18.1591 19.3768 18.5716C19.4149 18.9841 19.1113 19.3492 18.6988 19.3873Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_945_13293">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UnlockIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4.0449 3.125 16.41 19.6695"
    width="16.41px"
    height="19.6695px"
  >
    <path
      d="M12.25 18.0342C12.0511 18.0342 11.8603 17.9552 11.7197 17.8145C11.579 17.6739 11.5 17.4831 11.5 17.2842V15.1172C11.5 14.9183 11.579 14.7275 11.7197 14.5869C11.8603 14.4462 12.0511 14.3672 12.25 14.3672C12.4489 14.3672 12.6397 14.4462 12.7803 14.5869C12.921 14.7275 13 14.9183 13 15.1172V17.2842C13 17.4831 12.921 17.6739 12.7803 17.8145C12.6397 17.9552 12.4489 18.0342 12.25 18.0342Z"
      fill={color}
      transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -1.7763568394002505e-15)"
    />
    <path
      d="M 17.099 6.422 C 17.099 6.422 15.745 7.158 15.649 6.935 C 15.554 6.713 15.436 6.501 15.299 6.302 C 15.162 6.104 15.006 5.919 14.832 5.751 C 14.66 5.578 14.472 5.424 14.27 5.29 C 14.068 5.157 13.852 5.044 13.626 4.954 C 13.4 4.863 13.166 4.797 12.928 4.754 C 12.69 4.712 12.447 4.694 12.204 4.7 C 11.722 4.704 11.251 4.802 10.814 4.984 C 10.378 5.166 9.977 5.432 9.635 5.772 C 9.294 6.112 9.026 6.512 8.841 6.947 C 8.657 7.383 8.557 7.854 8.551 8.336 L 8.551 9.385 L 8.551 10.435 C 8.551 10.535 8.531 10.632 8.494 10.723 C 8.456 10.813 8.401 10.895 8.331 10.966 C 8.261 11.036 8.178 11.091 8.088 11.128 C 7.998 11.166 7.9 11.185 7.801 11.185 C 7.701 11.185 7.604 11.166 7.514 11.128 C 7.424 11.091 7.341 11.036 7.27 10.966 C 7.2 10.895 7.145 10.813 7.108 10.723 C 7.071 10.632 7.051 10.535 7.051 10.435 L 7.051 9.378 L 7.051 8.32 C 7.052 7.63 7.189 6.955 7.449 6.33 C 7.708 5.705 8.09 5.131 8.578 4.644 C 9.066 4.157 9.641 3.777 10.266 3.519 C 10.891 3.261 11.567 3.124 12.256 3.125 C 12.946 3.126 13.621 3.263 14.246 3.523 C 14.871 3.782 15.445 4.164 15.932 4.652 C 16.419 5.14 17.1 5.732 17.099 6.422 Z"
      fill={color}
      transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -1.7763568394002505e-15)"
    />
    <path
      d="M14.9498 22.7494H9.54985C8.42483 22.8714 7.28675 22.7451 6.21585 22.3794C5.44858 22.0094 4.82925 21.3904 4.45885 20.6234C4.09438 19.5522 3.96844 18.4143 4.08984 17.2894V15.1574C3.96826 14.0328 4.09421 12.8952 4.45885 11.8244C4.829 11.0566 5.44881 10.4371 6.21685 10.0674C7.28742 9.70177 8.42516 9.57547 9.54985 9.69739H14.9498C16.0745 9.57564 17.2122 9.70193 18.2828 10.0674C19.0509 10.4373 19.6704 11.0572 20.0398 11.8254C20.4055 12.8956 20.5318 14.033 20.4099 15.1574V17.2864C20.5317 18.4114 20.4054 19.5495 20.0398 20.6204C19.6696 21.3879 19.0498 22.0071 18.2818 22.3764C17.2119 22.743 16.0744 22.8704 14.9498 22.7494ZM9.54985 11.1974C8.64947 11.106 7.73996 11.1813 6.86684 11.4194C6.40533 11.641 6.03294 12.0131 5.81084 12.4744C5.57375 13.3477 5.49885 14.2571 5.58984 15.1574V17.2864C5.49908 18.1874 5.57398 19.0974 5.81084 19.9714C6.03383 20.4312 6.40559 20.8023 6.86585 21.0244C7.73932 21.2624 8.64914 21.3376 9.54985 21.2464H14.9498C15.8502 21.3376 16.7597 21.2624 17.6329 21.0244C18.0936 20.8025 18.4655 20.4309 18.6879 19.9704C18.9259 19.0969 19.0011 18.1871 18.9099 17.2864V15.1544C19.0012 14.254 18.926 13.3445 18.6879 12.4714C18.4662 12.0105 18.0946 11.6385 17.6339 11.4164C16.7604 11.1785 15.8506 11.1033 14.9498 11.1944L9.54985 11.1974Z"
      fill={color}
      transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -1.7763568394002505e-15)"
    />
  </svg>
);

export const FilterIcon = ({ color = MENU_ICON_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Top line with circle at the right */}
    <path
      d="M4 6H16"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="20" cy="6" r="2" stroke={color} strokeWidth="1.5" fill="none" />

    {/* Middle line with circle in the center */}
    <path
      d="M4 12H20"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="2"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />

    {/* Bottom line with circle at the left */}
    <path
      d="M8 18H20"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="4" cy="18" r="2" stroke={color} strokeWidth="1.5" fill="none" />
  </svg>
);
